(() => {
"use strict";
/* ---------- Originály z Fusion 360 (rozměry v mm při výšce 200) ---------- */
// společné: trubka Ø25 (dutina Ø23, hloubka 190), dno 2 mm
const DEFAULTS = {N:25, A:0, C:5, T:0, ZN:25, D:23, Q:null, B:2, BN:20, BS:24, BR:60, BK:16, BD:45, seed:1};
const HEIGHTS = [150, 200, 250, 300, 400, 600];
// doporučená tryska k výšce → stěna 0,8 / 1,0 / 1,25 / 1,5 / 2,0 / 3,0 mm
const HEIGHT_NOZZLE = {150:0.4, 200:0.4, 250:0.6, 300:0.6, 400:0.8, 600:1};
const BZ = (pts, h) => ({pts, h, curve:"bezier"});
const H0 = {dz:0, dr:0};
const STYLES = {
  wave: {name:"WAVE", base:{N:25, A:2.46, C:5, T:0},
    hint:"Žebra se po výšce vlní do stran (sinus).",
    presets:{
      // přesné profily z Fusionu (úsečky + oblouky → Bézier); WAVE-02/03/04 mají stejný tvar jako SPIRAL-02/03/04 (WAVE-03 se zaoblenými vnitřními rohy)
      "WAVE-01": BZ([[0,25],[0.125,36.5],[0.20807,35.92],[0.32003,32.573],[0.34007,31.499],[0.45203,28.153],[0.65445,26.739],[0.74402,24.062],[0.78098,22.081],[0.87055,19.404],[1,18.5]],
        [{in:H0,out:{dz:0.03022,dr:7.573},corner:true},{in:{dz:-0.04842,dr:0.338},out:{dz:0.02769,dr:-0.193},corner:false},{in:{dz:-0.02769,dr:0.193},out:{dz:0.03783,dr:-0.264},corner:false},{in:{dz:-0.03657,dr:1.96},out:{dz:0.00668,dr:-0.358},corner:false},{in:{dz:-0.00668,dr:0.358},out:{dz:0.03657,dr:-1.96},corner:false},{in:{dz:-0.03783,dr:0.264},out:{dz:0.06748,dr:-0.471},corner:false},{in:{dz:-0.06748,dr:0.471},out:{dz:0.03027,dr:-0.211},corner:false},{in:{dz:-0.02925,dr:1.568},out:{dz:0.01232,dr:-0.66},corner:false},{in:{dz:-0.01232,dr:0.66},out:{dz:0.02925,dr:-1.568},corner:false},{in:{dz:-0.03027,dr:0.211},out:{dz:0.04315,dr:-0.301},corner:false},{in:{dz:-0.04315,dr:0.301},out:H0,corner:true}]),
      "WAVE-02": null, "WAVE-03": null, "WAVE-04": null   // doplněno níž ze SPIRAL
    }},
  // ZIGZAG: 25 žeber 0,9 mm, bok žebra střídá +5 / −4,33 mm každých 20 mm (5 zubů)
  // náklon zubu 25° (0° = svislé žebro) ≙ výchylka 4,67 mm při 5 zubech na 200 mm (tg = 4·A·C/200)
  zigzag: {name:"ZIGZAG", base:{N:25, ZN:25, C:5, T:0},
    hint:"Žebra jdou po výšce cik-cak s ostrými zuby.",
    presets:{
      "ZIGZAG-01": BZ([[0,25],[0.2,39],[0.3,27.5],[0.4,35],[0.7,19.595],[1,17.5]],
        [{in:H0,out:{dz:0.06014,dr:7.784},corner:true},{in:{dz:-0.07129,dr:-1.416},out:{dz:0.03333,dr:-3.833},corner:true},{in:{dz:-0.03333,dr:3.833},out:{dz:0.03333,dr:2.5},corner:true},{in:{dz:-0.03333,dr:-2.5},out:{dz:0.09324,dr:-9.42},corner:true},{in:{dz:-0.1044,dr:0.729},out:{dz:0.1,dr:-0.698},corner:false},{in:{dz:-0.1,dr:0.698},out:H0,corner:true}]),
      "ZIGZAG-02": BZ([[0,25],[0.2,39],[0.3,39],[0.7,19.595],[1,17.5]],
        [{in:H0,out:{dz:0.0709,dr:1.755},corner:true},{in:{dz:-0.0609,dr:-7.471},out:{dz:0.03333,dr:0},corner:true},{in:{dz:-0.03333,dr:0},out:{dz:0.12536,dr:-11.835},corner:true},{in:{dz:-0.13854,dr:0.968},out:{dz:0.1,dr:-0.698},corner:false},{in:{dz:-0.1,dr:0.698},out:H0,corner:true}]),
      "ZIGZAG-03": BZ([[0,32],[0.2,29],[0.3,39],[0.8,18.897],[1,17.5]],
        [{in:H0,out:{dz:0.06667,dr:-1},corner:true},{in:{dz:-0.06667,dr:1},out:{dz:0.03333,dr:3.333},corner:true},{in:{dz:-0.03333,dr:-3.333},out:{dz:0.16006,dr:-12.118},corner:true},{in:{dz:-0.17104,dr:1.195},out:{dz:0.06667,dr:-0.466},corner:false},{in:{dz:-0.06667,dr:0.466},out:H0,corner:true}]),
      "ZIGZAG-04": BZ([[0,30],[0.2,39],[0.5,20.992],[1,17.5]],
        [{in:H0,out:{dz:0.06667,dr:3},corner:true},{in:{dz:-0.06667,dr:-3},out:{dz:0.09059,dr:-11.064},corner:true},{in:{dz:-0.10608,dr:0.741},out:{dz:0.16667,dr:-1.164},corner:false},{in:{dz:-0.16667,dr:1.164},out:H0,corner:true}])
    }},
  // SPIRAL: 20 radiálních žeber 1 mm tažených po šroubovici, 0,75 otáčky na 200 mm
  spiral: {name:"SPIRAL", base:{N:20, A:0, T:270},
    hint:"Rovná žebra stočená do šroubovice.",
    presets:{
      "SPIRAL-01": BZ([[0,25],[0.125,36.368],[0.19613,35.871],[0.25315,34.37],[0.34685,30.043],[0.40387,28.542],[0.64613,26.85],[0.70315,25.349],[0.79685,21.022],[0.85387,19.521],[1,18.5]],
        [{in:H0,out:{dz:0.03046,dr:7.497},corner:true},{in:{dz:-0.04827,dr:0.337},out:{dz:0.02371,dr:-0.166},corner:false},{in:{dz:-0.02371,dr:0.166},out:{dz:0.0192,dr:-0.134},corner:false},{in:{dz:-0.01872,dr:0.864},out:{dz:0.03124,dr:-1.442},corner:false},{in:{dz:-0.03124,dr:1.442},out:{dz:0.01872,dr:-0.864},corner:false},{in:{dz:-0.0192,dr:0.134},out:{dz:0.08075,dr:-0.564},corner:false},{in:{dz:-0.08075,dr:0.564},out:{dz:0.0192,dr:-0.134},corner:false},{in:{dz:-0.01872,dr:0.864},out:{dz:0.03124,dr:-1.442},corner:false},{in:{dz:-0.03124,dr:1.442},out:{dz:0.01872,dr:-0.864},corner:false},{in:{dz:-0.0192,dr:0.134},out:{dz:0.04871,dr:-0.34},corner:false},{in:{dz:-0.04871,dr:0.34},out:H0,corner:true}]),
      "SPIRAL-02": BZ([[0,22.5],[0.2623,35.938],[0.75424,18.216],[1,16.5]],
        [{in:H0,out:{dz:0.06669,dr:14.381},corner:true},{in:{dz:-0.09304,dr:6.198},out:{dz:0.15889,dr:-10.584},corner:false},{in:{dz:-0.16737,dr:1.169},out:{dz:0.08192,dr:-0.572},corner:false},{in:{dz:-0.08192,dr:0.572},out:H0,corner:true}]),
      "SPIRAL-03": BZ([[0,25],[0.42754,23.914],[0.48184,23.163],[0.75266,19.487],[0.78783,18.919],[1,15]],
        [{in:H0,out:{dz:0.13311,dr:15.046},corner:true},{in:{dz:-0.13116,dr:15.717},out:{dz:0.01646,dr:-1.972},corner:false},{in:{dz:-0.01766,dr:-1.5},out:{dz:0.08804,dr:7.48},corner:false},{in:{dz:-0.08218,dr:9.791},out:{dz:0.01065,dr:-1.269},corner:false},{in:{dz:-0.01153,dr:-0.911},out:{dz:0.06982,dr:5.515},corner:false},{in:{dz:-0.06359,dr:7.979},out:H0,corner:true}]),
      "SPIRAL-04": BZ([[0,22.5],[0.25,35],[0.43874,29.52],[0.6,19.954],[0.685,18.7],[1,16.5]],
        [{in:H0,out:{dz:0.07694,dr:8.207},corner:true},{in:{dz:-0.0872,dr:0},out:{dz:0.0639,dr:0},corner:false},{in:{dz:-0.06127,dr:3.634},out:{dz:0.05375,dr:-3.189},corner:false},{in:{dz:-0.05375,dr:3.189},out:{dz:0.02755,dr:-1.635},corner:false},{in:{dz:-0.02845,dr:-0.808},out:{dz:0.10483,dr:2.978},corner:false},{in:{dz:-0.10354,dr:4.433},out:H0,corner:true}])
    }},
  // BUBBLES: 30 rovných žeber ořezaných sjednocením koulí (odsazení 11 mm od osy, poloměr 24 → 10 mm), jádro r16
  bubbles: {name:"BUBBLES", base:{N:30, A:0, T:0, BN:20, BS:24, BS2:9, BR:60, BK:16},
    hint:"Profil určuje, kam až bubliny sahají; velikost bublin se zmenšuje spolu s profilem.",
    presets:{
      "BUBBLES-01": {pts:[[0,35.1],[1,20.1]], curve:"lines", set:{seed:1}},
      "BUBBLES-02": {pts:[[0,35.1],[1,20.1]], curve:"lines", set:{seed:2}},
      "BUBBLES-03": {pts:[[0,35.1],[1,20.1]], curve:"lines", set:{seed:3}},
      "BUBBLES-04": {pts:[[0,35.1],[1,20.1]], curve:"lines", set:{seed:4}}
    }},
  // SPIRAL BUBBLES: spirálová žebra SPIRAL ořezaná koulemi (odsazení 10 mm, poloměr 26 → 10 mm)
  sbubbles: {name:"SPIRAL BUBBLES", base:{N:20, A:0, T:270, BN:21, BS:26, BS2:8.5, BR:60, BK:16},
    hint:"Spirálová žebra ořezaná bublinami.",
    presets:{
      "SPIRAL-BUBBLES-01": {pts:[[0,36.4],[1,18.9]], curve:"lines", set:{seed:7}}
    }},
  // CORE: rovná žebra po celé výšce profilu, koule do nich ostře vyřezávají výřezy
  core: {name:"CORE", base:{N:30, A:0, T:0, BN:20, BS:24, BS2:9, BR:60, BD:45},
    hint:"Žebra jdou celou výškou po profilu, koule do nich ostře vyřezávají výřezy. Hloubka 100 % znamená, že koule sahá až 1 mm před trubku.",
    presets:{
      "CORE-01": {pts:[[0,35.1],[1,20.1]], curve:"bezier", set:{seed:1}},
      "CORE-02": {pts:[[0,35.1],[1,20.1]], curve:"bezier", set:{seed:2}},
      "CORE-03": {pts:[[0,35.1],[1,20.1]], curve:"bezier", set:{seed:3}},
      "CORE-04": {pts:[[0,35.1],[1,20.1]], curve:"bezier", set:{seed:4}}
    }}
};
for (const n of ["02","03","04"]) STYLES.wave.presets["WAVE-" + n] = STYLES.spiral.presets["SPIRAL-" + n];
const firstPreset = style => Object.keys(STYLES[style].presets)[0];
// tiskový prostor v mm (u řady H bezpečnější údaj: prostor pro obě trysky, nižší udávaná výška)
const PRINTERS = {
  a1m: {name:"Bambu Lab A1 mini", x:180, y:180, z:180},
  a1:  {name:"Bambu Lab A1",      x:256, y:256, z:256},
  p1s: {name:"Bambu Lab P1S",     x:256, y:256, z:256},
  h2d: {name:"Bambu Lab H2D",     x:300, y:320, z:325},
  h2s: {name:"Bambu Lab H2S",     x:340, y:320, z:340},
  h2c: {name:"Bambu Lab H2C",     x:300, y:320, z:320},
  mini:{name:"Prusa MINI",        x:180, y:180, z:180},
  mk4: {name:"Prusa MK4",         x:250, y:210, z:220},
  c1:  {name:"Prusa CORE One",    x:250, y:220, z:270},
  c1l: {name:"Prusa CORE One L",  x:300, y:300, z:330},
  xl:  {name:"Prusa XL",          x:360, y:360, z:360}
};
const COLORS = [["Měď","#B8733D"],["Pískovec","#CDB89A"],["Porcelán","#ECE9E2"],["Mech","#6F7F5A"],["Kobalt","#2F4A8A"],["Grafit","#3A3D40"],["Korál","#D8664F"]];
const PLA_DENSITY = 1.24;
const FIN_T = 1.0;    // tloušťka žebra u 200mm vázy, mění se poměrově s výškou
const TUBE_W = 1.0;   // stěna trubky u 200mm vázy, mění se poměrově s výškou
const OV_TOL = 0.5;   // tolerance zaokrouhlení: plocha skloněná přesně na limit převisu se nehlásí

const clone = o => JSON.parse(JSON.stringify(o));
function presetState(style, name){
  const S = STYLES[style], p = S.presets[name];
  const st = Object.assign({style, preset:name, H:200}, DEFAULTS, S.base, p.set || {});
  st.profile = clone(p.pts); st.curve = p.curve || "smooth"; st.handles = p.h ? clone(p.h) : null;
  return st;
}
// starší uložené vázy nemají styl ani nové parametry
function normalizeState(st){
  if (st.style === "zigzag" && st.ZN === undefined){   // starší ZIGZAG: náklon od podložky (ZB), od svislice (ZA) nebo výchylka v mm (A)
    const n = st.ZB !== undefined ? 90 - st.ZB : st.ZA !== undefined ? st.ZA : st.C > 0 ? Math.atan(4*(st.A ?? 4.67)*st.C/200)*180/Math.PI : 25;
    st = Object.assign({}, st, {ZN: +Math.min(50, Math.max(0, n)).toFixed(1)});
  }
  const out = Object.assign({}, DEFAULTS, STYLES.wave.base, st);
  if (!STYLES[out.style]) out.style = "wave";
  if (out.Q === 190) out.Q = null;   // dřívější výchozí hloubka dutiny → nově plná
  out.H = HEIGHTS.reduce((a, h) => Math.abs(h - out.H) < Math.abs(a - out.H) ? h : a, 200);   // jen pevné výšky
  if (out.bmode === "concave" && (out.style === "bubbles" || out.style === "sbubbles")) out.style = "core";   // dřívější vyduté bubliny
  delete out.bmode; delete out.BZ; delete out.BI;
  if (!out.curve) out.curve = "smooth";
  return out;
}
const settings = {printer:"p1s", nozzle:0.4, M:0.8, keepMin:true, O:45, showOv:true, color:"#B8733D", snap:false, grid:"auto",
  logo:null, logoInv:false, LS:30, LD:0.8, LR:0,
  cutV:false, cutH:false, CV:0, CH:50};   // řez náhledem   // logo: {name, loops:[[u,v,…]]} v jednotkových souřadnicích
let state = presetState("wave", "WAVE-01");
const shapeOf = st => clone({profile:st.profile, curve:st.curve||"smooth", handles:st.handles||null});
let origShape = shapeOf(state);
let sel = -1;   // vybraný bod profilu

/* ---------- PCHIP interpolace profilu ---------- */
function pchip(pts){
  const xs = pts.map(p=>p[0]), ys = pts.map(p=>p[1]), n = xs.length;
  const h=[], d=[], m=new Array(n);
  for (let i=0;i<n-1;i++){ h[i]=xs[i+1]-xs[i]; d[i]=(ys[i+1]-ys[i])/h[i]; }
  if (n===2){ m[0]=m[1]=d[0]; }
  else {
    m[0]=d[0]; m[n-1]=d[n-2];
    for (let i=1;i<n-1;i++){
      if (d[i-1]*d[i]<=0) m[i]=0;
      else { const w1=2*h[i]+h[i-1], w2=h[i]+2*h[i-1]; m[i]=(w1+w2)/(w1/d[i-1]+w2/d[i]); }
    }
  }
  return x => {
    if (x<=xs[0]) return ys[0]; if (x>=xs[n-1]) return ys[n-1];
    let lo=0, hi=n-1; while (hi-lo>1){ const mid=(lo+hi)>>1; if (xs[mid]>x) hi=mid; else lo=mid; }
    const i=lo, t=(x-xs[i])/h[i], t2=t*t, t3=t2*t;
    return (2*t3-3*t2+1)*ys[i]+(t3-2*t2+t)*h[i]*m[i]+(-2*t3+3*t2)*ys[i+1]+(t3-t2)*h[i]*m[i+1];
  };
}

/* ---------- Profil: hladká / Bézier / rovné úseky ---------- */
// z je normované 0..1, r v mm při výšce 200. Úchyty Bézieru jsou relativní {dz, dr}.
function tableFn(zs, rs){
  const n = zs.length;
  return x => {
    if (x <= zs[0]) return rs[0]; if (x >= zs[n-1]) return rs[n-1];
    let lo = 0, hi = n-1; while (hi-lo > 1){ const mid = (lo+hi)>>1; if (zs[mid] > x) hi = mid; else lo = mid; }
    const t = (x - zs[lo])/((zs[hi]-zs[lo]) || 1);
    return rs[lo] + (rs[hi]-rs[lo])*t;
  };
}
// omezení úchytů: z musí zůstat v polovině sousedního úseku (křivka tak zůstane funkcí výšky)
function handleZ(P, i, h, side){
  if (side === "out"){ const lim = i < P.length-1 ? (P[i+1][0]-P[i][0])/2 : 0; return Math.min(lim, Math.max(0, h.dz)); }
  const lim = i > 0 ? (P[i][0]-P[i-1][0])/2 : 0; return Math.max(-lim, Math.min(0, h.dz));
}
function bezierSegments(P, Hs){
  const zs = [], rs = [];
  for (let i=0;i<P.length-1;i++){
    const o = Hs[i].out, n = Hs[i+1].in;
    const z0 = P[i][0], r0 = P[i][1], z3 = P[i+1][0], r3 = P[i+1][1];
    const z1 = z0 + handleZ(P,i,o,"out"), r1 = r0 + o.dr;
    const z2 = z3 + handleZ(P,i+1,n,"in"), r2 = r3 + n.dr;
    const steps = 48;
    for (let k = (i ? 1 : 0); k <= steps; k++){
      const t = k/steps, u = 1-t, a = u*u*u, b = 3*u*u*t, c = 3*u*t*t, d = t*t*t;
      zs.push(a*z0+b*z1+c*z2+d*z3); rs.push(a*r0+b*r1+c*r2+d*r3);
    }
  }
  return {zs, rs};
}
function curveFn(st){
  const P = st.profile;
  if (st.curve === "lines") return tableFn(P.map(p=>p[0]), P.map(p=>p[1]));
  if (st.curve === "bezier"){
    if (!st.handles || st.handles.length !== P.length) st.handles = autoHandles(P, pchip(P));
    const {zs, rs} = bezierSegments(P, st.handles);
    return tableFn(zs, rs);
  }
  return pchip(P);
}
// úchyty, které přesně kopírují zadanou křivku (Hermite -> Bézier)
function autoHandles(P, f, corner){
  const e = 1e-4;
  return P.map((p,i) => {
    const zl = i > 0 ? P[i-1][0] : null, zr = i < P.length-1 ? P[i+1][0] : null;
    const mL = zl !== null ? (f(p[0]) - f(p[0]-e))/e : 0;
    const mR = zr !== null ? (f(p[0]+e) - f(p[0]))/e : 0;
    const dzIn = zl !== null ? -(p[0]-zl)/3 : 0, dzOut = zr !== null ? (zr-p[0])/3 : 0;
    return {in:{dz:dzIn, dr:mL*dzIn}, out:{dz:dzOut, dr:mR*dzOut}, corner: !!corner};
  });
}
function lineHandles(P){
  return P.map((p,i) => {
    const L = P[i-1], R = P[i+1];
    return {in: L ? {dz:(L[0]-p[0])/3, dr:(L[1]-p[1])/3} : {dz:0, dr:0},
            out: R ? {dz:(R[0]-p[0])/3, dr:(R[1]-p[1])/3} : {dz:0, dr:0}, corner:true};
  });
}
function setCurveMode(mode){
  if (mode === state.curve || (linesOnly() && mode !== "lines")) return;
  if (mode === "bezier") state.handles = state.curve === "lines" ? lineHandles(state.profile) : autoHandles(state.profile, pchip(state.profile));
  state.curve = mode;
  syncCurveUI(); schedule();
}

/* ---------- Odvozené rozměry (škálování + tisknutelnost) ---------- */
function derive(){
  const s = state.H/200;
  const minT = settings.M;
  const scaleT = v => settings.keepMin ? Math.max(v*s, minT) : v*s;
  const t = scaleT(FIN_T);   // žebro 1,0 mm u 200mm vázy, roste s výškou (min. dle tisknutelnosti)
  const wall = scaleT(TUBE_W);   // stěna trubky 1,0 mm u 200mm vázy, roste s výškou (min. dle trysky)
  const rc = state.D*s/2;
  const Rt = rc + wall;
  const H = state.H;
  const rz = 0;   // zvednuté dno (prolis) – zatím nepoužito
  const bp = rz + Math.max(state.B*s, 0.6);         // horní plocha podstavy (začátek žeber nad deskou)
  // dutina: výchozí plná (až na podstavu), jinak zadaná hloubka (uložená pro 200mm vázu, mění se s výškou)
  const floorZ = state.Q == null ? bp : Math.min(H-2, Math.max(H - state.Q*s, bp));
  const sty = state.style;
  const waveOn = sty === "wave" || sty === "zigzag";
  const bub = sty === "bubbles" || sty === "sbubbles" || sty === "core";
  const cyc = waveOn ? state.C : 0;
  // ZIGZAG: výchylka z náklonu zubu, 0° = svislé žebro (bok přejde 2·A na výšce H/(2·C))
  let A = sty === "wave" ? state.A*s : sty === "zigzag" && cyc > 0 ? Math.tan(state.ZN*Math.PI/180)*H/(4*cyc) : 0;
  const Amax = Math.max(0, Rt*0.8 - t/2);   // víc by žebro sjelo z trubky
  const Aclamped = A > Amax;
  if (Aclamped) A = Amax;
  const sharp = sty === "zigzag" ? 1 : 0;   // ZIGZAG má vždy ostré zuby
  const twist = sty === "bubbles" || sty === "core" || sty === "zigzag" ? 0 : state.T*Math.PI/180;
  const Rmin = Rt + Math.max(1.2, 1.5*t);
  const f = curveFn(state);
  const R0f = z => Math.max(f(z/H)*s, Rmin);
  // WAVE a SPIRAL: horní vnější roh žebra zaoblený (v originále Fillet R3 mm u 200mm vázy)
  let R = R0f, filZ = [];
  if (sty === "wave" || sty === "spiral"){
    const rf = 3*s, Rtop = f(1)*s, m = (f(1) - f(1 - 1e-3))*s/(H*1e-3);   // m = dR/dz u horní hrany
    const L = Math.hypot(m, 1), th = Math.acos(Math.max(-0.99, Math.min(0.99, m/L)));   // vnitřní úhel rohu
    const tl = Math.min(rf/Math.tan(th/2), Math.max(0, Rtop - Rmin), 0.25*H);
    const rr = tl*Math.tan(th/2);   // skutečný poloměr (zmenšený, když by roh zasáhl k trubce)
    const z0 = H - tl/L, cR = Rtop - tl, cz = H - rr;
    if (rr > 0.05){
      R = z => {
        if (z <= z0) return R0f(z);
        const dz = Math.min(rr, z - cz), circ = cR + Math.sqrt(Math.max(0, rr*rr - dz*dz));
        return Math.max(Rmin, circ + f(z/H)*s - (Rtop + m*(z - H)));   // oblouk + odchylka profilu od tečny
      };
      const a0 = Math.asin(Math.max(-1, Math.min(1, (z0 - cz)/rr))), nA = 10;
      for (let i=1;i<nA;i++) filZ.push(cz + rr*Math.sin(a0 + (Math.PI/2 - a0)*i/nA));
      filZ.unshift(z0);
    }
  }
  let Rprof = 0; for (let i=0;i<=200;i++) Rprof = Math.max(Rprof, f(i/200)*s);
  const breaks = state.curve === "smooth" ? [] : state.profile.map(p => p[0]*H);
  // boční výchylka žebra: sinus, se zvyšující se ostrostí přechází v trojúhelník (cik-cak)
  const TAU = Math.PI*2;
  const wave = z => {
    if (!A) return 0;
    const ph = TAU*cyc*z/H; let v = Math.cos(ph);
    if (sharp > 0){ const u = ((ph/TAU) % 1 + 1) % 1; v = (1-sharp)*v + sharp*(4*Math.abs(u-0.5) - 1); }
    return A*v;
  };
  if (sharp > 0 && A && cyc > 0) for (let k=1; k < 2*cyc; k++) breaks.push(H*k/(2*cyc));   // špičky zubů
  { const kept = []; for (const b of breaks) if (!kept.some(x => Math.abs(x - b) < 0.3)) kept.push(b); breaks.splice(0, breaks.length, ...kept); }   // bez téměř shodných vrstev (tenké trojúhelníky)
  // maximální počet žeber, aby mezi nimi na trubce zůstala mezera
  const maxN = Math.max(3, Math.floor(2*Math.PI*Rt/(t*2.2)));
  const N = Math.min(state.N, maxN);
  const Rfloor = sty === "core" ? Rt + 1 : Rmin;   // CORE: výřez smí jít až 1 mm před trubku
  const env = bub ? bubbleEnvelope({s, H, f, Rprof, Rmin, Rfloor, Rt, keepBase: sty === "core" && !!state.CB ? bp : -1}) : null;
  // silueta pro 2D editor: u bublin největší poloměr obálky v dané výšce
  const Rsil = env ? z => { let m = 0; for (let k=0;k<72;k++) m = Math.max(m, env(z, TAU*k/72, R(z))); return m; } : R;
  return {s, t, wall, rc, Rt, H, bp, floorZ, A, R, N, maxN, cyc, twist, Rmin, Rfloor, inset: 0 /* zapuštěná podstava mezi žebra (>0) – zatím nepoužito, deska jde po konce žeber */, rz, breaks, filZ, wave, env, Rprof, Rsil, bub: bub && sty !== "core", Aclamped};
}

/* ---------- Bubliny: koule rozmístěné kolem osy, žebra je ořezávají ---------- */
function mulberry32(a){ return () => { a |= 0; a = a + 0x6D2B79F5 | 0; let t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0)/4294967296; }; }
function bubbleEnvelope({s, H, f, Rprof, Rmin, Rfloor, Rt, keepBase = -1}){
  const rand = mulberry32(state.seed*7919 + 13);
  const n = Math.round(state.BN), rr = state.BR/100, TAU = Math.PI*2;
  const size = state.BS*s;
  const off = Math.max(0, Rprof - size);          // odsazení středů koulí od osy (dřívější způsob, BS2 nezadáno)
  // velikost bubliny podle šířky vázy: BS v nejširším, BS2 v nejužším místě profilu, mezi nimi plynule
  let Rn = Infinity; for (let i=0;i<=200;i++) Rn = Math.min(Rn, f(i/200)*s);
  const sizeAt = Rz => {
    if (state.BS2 == null) return Rz - off;
    const t = Rprof - Rn > 1e-6 ? Math.min(1, Math.max(0, (Rz - Rn)/(Rprof - Rn))) : 1;
    return state.BS2*s + (size - state.BS2*s)*t;
  };
  const concave = state.style === "core";
  const core = Math.max(Rmin, state.BK*s);
  const balls = [];
  for (let i=0;i<n;i++){
    const j1 = rand(), j2 = rand(), j3 = rand();
    const zc = Math.min(H, Math.max(0, H*(i + 0.5 + rr*0.9*(j1-0.5))/n));
    const ang = (1-rr)*i*2.39996 + rr*j2*TAU;       // bez nahodilosti po zlatém úhlu
    const Rz = f(zc/H)*s;
    const rs0 = Math.max(2, sizeAt(Rz));
    let rs = rs0 * (1 + rr*0.3*(j3-0.5));
    if (concave){   // CORE: koule zanořená pod profil; 100 % = nejhlubší bod koule 1 mm před trubkou (čistý kulový řez, žádná rovina)
      const rd = Math.max(3, rs);
      // volba „výřezy nezasahují do dna“: koule se posune nahoru, aby se spodní desky vůbec nedotkla
      const zk = keepBase >= 0 ? Math.max(zc, keepBase + rd + 0.01) : zc;
      const Rk = keepBase >= 0 ? f(Math.min(1, zk/H))*s : Rz;
      const depth = Math.max(0, Rk - Rfloor) * Math.min(1, Math.max(0, state.BD/100));
      balls.push({zc:zk, rs:rd, d:Rk + rd - depth, ca:Math.cos(ang), sa:Math.sin(ang)});
    }
    else {
      // bubliny nepřesahují horní okraj: koule se posune dolů, aby její nejvyšší bod zůstal pod hranou vázy
      let zb = zc, Rb = Rz, rb0 = rs0, rb = rs;
      for (let k=0; k<3 && zb + rb > H; k++){
        zb = Math.max(0, H - rb - 0.01); Rb = f(zb/H)*s;
        rb0 = Math.max(2, sizeAt(Rb)); rb = rb0*(1 + rr*0.3*(j3-0.5));
      }
      if (zb + rb > H) rb = Math.max(1, H - zb - 0.01);
      // bublina se dotýká profilu (u původního způsobu = off), ale její střed smí být od povrchu středové trubky
      // nejvýš polovinu průměru koule → koule vždy dosáhne k trubce (žádné odtržené bubliny ani tenké trny)
      const d = Math.min(Math.max(0, Rb - rb0), Rt + rb);
      balls.push({zc:zb, rs:rb, d, ca:Math.cos(ang), sa:Math.sin(ang)});
    }
  }
  let zKey = null, live = [];
  // poloměr obálky v úhlu phi a výšce z (průsečík paprsku z osy s koulemi)
  return (z, phi, Rbase) => {
    if (z !== zKey){
      zKey = z; live = [];
      for (const b of balls){ const dz = z - b.zc; const r2 = b.rs*b.rs - dz*dz; if (r2 > 0) live.push([b, r2]); }
    }
    const c = Math.cos(phi), sn = Math.sin(phi);
    if (!concave){
      let R = core;
      for (const [b, r2] of live){
        const along = b.d*(b.ca*c + b.sa*sn), across = b.d*(b.sa*c - b.ca*sn);
        const q = r2 - across*across; if (q <= 0) continue;
        const e = along + Math.sqrt(q); if (e > R) R = e;
      }
      return R;
    }
    // CORE: žebro končí tam, kde paprsek z osy vstoupí do koule; žebra zůstanou celou výšku (nejméně Rmin)
    if (z <= keepBase + 1e-6) return Rbase;   // volba „výřezy nezasahují do dna“: deska zůstane celá
    let R = Rbase;
    for (const [b, r2] of live){
      const along = b.d*(b.ca*c + b.sa*sn), across = b.d*(b.sa*c - b.ca*sn);
      const q = r2 - across*across; if (q <= 0) continue;
      if (along <= 0 && b.d*b.d >= r2) continue;   // koule za osou paprsek nezasáhne (pokud osu neobklopuje)
      const e = along - Math.sqrt(q); if (e < R) R = e;
    }
    return Math.max(Rfloor, R);
  };
}

/* ---------- Logo: obrázek → obrysy (marching squares) ---------- */
// vrací smyčky [u0,v0,u1,v1,…] v jednotkových souřadnicích: střed obrysu v 0, delší strana = 1, v roste dolů (jako v obrázku)
function traceLogo(img, invert){
  const maxPx = 600;
  let w0 = img.naturalWidth || img.width || maxPx, h0 = img.naturalHeight || img.height || maxPx;
  const k = maxPx/Math.max(w0, h0), w = Math.max(2, Math.round(w0*k)), h = Math.max(2, Math.round(h0*k));
  const cv = document.createElement("canvas"); cv.width = w; cv.height = h;
  const cx = cv.getContext("2d"); cx.drawImage(img, 0, 0, w, h);
  const px = cx.getImageData(0, 0, w, h).data;
  let alpha = false; for (let i=3;i<px.length;i+=4) if (px[i] < 250){ alpha = true; break; }
  const ink = new Uint8Array(w*h);
  for (let i=0;i<w*h;i++){
    const r = px[4*i], g = px[4*i+1], b = px[4*i+2], a = px[4*i+3];
    // průhledný obrázek: logo = neprůhledné části; jinak logo = tmavé části (invertovat = světlé části)
    let v = alpha ? a > 127 : (0.299*r + 0.587*g + 0.114*b) < 128;
    if (invert && !alpha) v = !v;
    ink[i] = v ? 1 : 0;
  }
  const at = (x, y) => (x < 0 || y < 0 || x >= w || y >= h) ? 0 : ink[y*w + x];
  // hrany buňky: T, R, B, L → body na zdvojené mřížce
  const E = (x, y, e) => e === 0 ? [2*x+1, 2*y] : e === 1 ? [2*x+2, 2*y+1] : e === 2 ? [2*x+1, 2*y+2] : [2*x, 2*y+1];
  const SEG = {1:[[3,2]], 2:[[2,1]], 3:[[3,1]], 4:[[0,1]], 5:[[0,1],[3,2]], 6:[[0,2]], 7:[[0,3]], 8:[[0,3]], 9:[[0,2]], 10:[[0,3],[2,1]], 11:[[0,1]], 12:[[3,1]], 13:[[2,1]], 14:[[3,2]]};
  const adj = new Map(), key = p => (p[0]+4)*100000 + (p[1]+4);
  const link = (a, b) => { const ka = key(a), kb = key(b); if (!adj.has(ka)) adj.set(ka, {p:a, n:[]}); if (!adj.has(kb)) adj.set(kb, {p:b, n:[]}); adj.get(ka).n.push(kb); adj.get(kb).n.push(ka); };
  for (let y=-1;y<h;y++) for (let x=-1;x<w;x++){
    const c = at(x,y)*8 + at(x+1,y)*4 + at(x+1,y+1)*2 + at(x,y+1);
    const s = SEG[c]; if (!s) continue;
    for (const [e1, e2] of s) link(E(x,y,e1), E(x,y,e2));
  }
  const loops = [], used = new Set();
  for (const [k0, node] of adj){
    if (used.has(k0)) continue;
    const pts = []; let prev = null, cur = k0;
    while (cur !== undefined && !used.has(cur)){
      used.add(cur); const nd = adj.get(cur); pts.push(nd.p[0]/2, nd.p[1]/2);
      const nx = nd.n.find(n => n !== prev && !used.has(n)); prev = cur; cur = nx;
    }
    if (pts.length >= 8) loops.push(pts);
  }
  // zjednodušení (Douglas–Peucker) a vyřazení drobností
  const simplify = (pts, tol) => {
    const n = pts.length/2; if (n < 4) return pts;
    const keep = new Uint8Array(n); keep[0] = 1;
    let far = 0, fd = -1; for (let i=1;i<n;i++){ const d2 = (pts[2*i]-pts[0])**2 + (pts[2*i+1]-pts[1])**2; if (d2 > fd){ fd = d2; far = i; } }
    keep[far] = 1;
    const rdp = (i0, i1) => {   // i1 může být n (= bod 0)
      const ax = pts[2*i0], ay = pts[2*i0+1], bx = pts[2*(i1%n)], by = pts[2*(i1%n)+1], L = Math.hypot(bx-ax, by-ay) || 1;
      let best = -1, bi = -1;
      for (let i=i0+1;i<i1;i++){ const d = Math.abs((bx-ax)*(ay-pts[2*i+1]) - (ax-pts[2*i])*(by-ay))/L; if (d > best){ best = d; bi = i; } }
      if (best > tol){ keep[bi] = 1; rdp(i0, bi); rdp(bi, i1); }
    };
    rdp(0, far); rdp(far, n);
    const out = []; for (let i=0;i<n;i++) if (keep[i]) out.push(pts[2*i], pts[2*i+1]);
    return out;
  };
  const area = p => { let a = 0; for (let i=0, n=p.length/2; i<n; i++){ const j = (i+1)%n; a += p[2*i]*p[2*j+1] - p[2*j]*p[2*i+1]; } return a/2; };
  const clean = loops.map(l => simplify(l, 0.7)).filter(l => l.length >= 6 && Math.abs(area(l)) > 6);
  if (!clean.length) return null;
  let x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
  for (const l of clean) for (let i=0;i<l.length;i+=2){ x0 = Math.min(x0, l[i]); x1 = Math.max(x1, l[i]); y0 = Math.min(y0, l[i+1]); y1 = Math.max(y1, l[i+1]); }
  const sc = 1/Math.max(x1-x0, y1-y0), cxm = (x0+x1)/2, cym = (y0+y1)/2;
  return clean.map(l => l.map((v, i) => +((i % 2 ? v - cym : v - cxm)*sc).toFixed(4)));
}
// logo v souřadnicích dna (mm): zrcadlené, aby se při pohledu zespodu četlo správně; s vnořením a orientací CCW
function logoGeometry(maxR){
  const L = settings.logo; if (!L || !L.loops || !L.loops.length) return null;
  let rU = 0; for (const l of L.loops) for (let i=0;i<l.length;i+=2) rU = Math.max(rU, Math.hypot(l[i], l[i+1]));
  const want = settings.LS*state.H/200;   // velikost loga je uložená pro 200mm vázu a mění se s výškou
  const size = Math.min(want, 0.92*maxR/Math.max(rU, 1e-6));
  const a = settings.LR*Math.PI/180, ca = Math.cos(a), sa = Math.sin(a);
  const polys = L.loops.map(l => {
    // nepatrný posun bodů (≤ 0,003 mm), aby body různých obrysů neležely přesně na jedné přímce (triangulace)
    const p = []; for (let i=0;i<l.length;i+=2){
      const j1 = Math.sin(i*12.9898 + l.length*78.233)*43758.5453, j2 = Math.sin(i*39.346 + l.length*11.135)*24634.6345;
      const x = -l[i]*size + (j1 - Math.floor(j1) - 0.5)*0.006, y = -l[i+1]*size + (j2 - Math.floor(j2) - 0.5)*0.006;
      p.push([x*ca - y*sa, x*sa + y*ca]);
    }
    let ar = 0; for (let i=0;i<p.length;i++){ const q = p[(i+1)%p.length]; ar += p[i][0]*q[1] - q[0]*p[i][1]; }
    if (ar < 0) p.reverse();
    return p;
  });
  const inside = (pt, poly) => { let c = false; for (let i=0, j=poly.length-1; i<poly.length; j=i++){ const [xi, yi] = poly[i], [xj, yj] = poly[j]; if ((yi > pt[1]) !== (yj > pt[1]) && pt[0] < (xj-xi)*(pt[1]-yi)/(yj-yi) + xi) c = !c; } return c; };
  const depth = polys.map((p, i) => polys.reduce((n, q, j) => n + (j !== i && inside(p[0], q) ? 1 : 0), 0));
  const parent = polys.map((p, i) => { let best = -1; polys.forEach((q, j) => { if (j !== i && depth[j] === depth[i]-1 && inside(p[0], q)) best = j; }); return best; });
  return {polys, depth, parent, size, clipped: size < want - 0.01};
}

let logoInfo = null;   // výsledek posledního vyřezání loga (pro popisek)

/* ---------- Stavba uzavřené (vodotěsné) sítě ---------- */
function buildMesh(d){
  const pos = [], idx = [];
  const V = (x,y,z) => { pos.push(x,y,z); return pos.length/3-1; };
  const N = d.N, TAU = Math.PI*2;
  const m = Math.max(1, Math.min(8, Math.ceil((TAU/N)/0.06)));   // body oblouku trubky mezi žebry
  const q = Math.max(2, Math.min(14, Math.ceil((TAU/N)/0.035)));  // body oblouku podstavy
  const ang = (x,y) => Math.atan2(y,x);

  // vodorovný řez žebrem je lichoběžník: šikmé žebro (vlna, zkroucení) musí být ve vodorovném řezu tlustší
  const kTw = d.twist/d.H, eps = 0.05;
  let plateT = null;   // poloměr rovné boční stěny dna u každého žebra (bok A, bok B); null = bez bočních bodů
  function finsAt(z){
    const ws = d.wave(z);
    const dwL = (ws - d.wave(z-eps))/eps, dwR = (d.wave(z+eps) - ws)/eps;
    const thAt = r => d.t/2*Math.max(Math.hypot(1, dwL + r*kTw), Math.hypot(1, dwR + r*kTw));
    const Rb = d.R(z), tw = d.twist*z/d.H;
    const thIn = thAt(d.Rt);
    const out = [];
    for (let k=0;k<N;k++){
      const phi = TAU*k/N + tw, c = Math.cos(phi), sn = Math.sin(phi);
      const R = d.env ? Math.max(d.Rfloor, d.env(z, phi, Rb)) : Rb;
      const thOut = thAt(R);
      const P = (s,x) => [s*c - x*sn, s*sn + x*c];
      const xai = ws-thIn, xbi = ws+thIn, xao = ws-thOut, xbo = ws+thOut;
      // u koulí leží každý bok žebra na obálce ve svém vlastním úhlu (navazuje na okraj desky bez schodu)
      const sideR = x => {
        if (!d.env) return R;
        let r = R;
        for (let it=0; it<3; it++){ const sx = Math.sqrt(Math.max(r*r - x*x, 1e-9)); r = Math.max(d.Rfloor, d.env(z, phi + Math.atan2(x, sx), Rb)); }
        return r;
      };
      const RA = sideR(xao), RB = sideR(xbo);
      const f = {
        Ain: P(Math.sqrt(d.Rt*d.Rt-xai*xai), xai), Aout: P(Math.sqrt(RA*RA-xao*xao), xao),
        Bout: P(Math.sqrt(RB*RB-xbo*xbo), xbo),     Bin: P(Math.sqrt(d.Rt*d.Rt-xbi*xbi), xbi), R
      };
      if (plateT){   // body na bocích žebra v poloměru rovné stěny dna (leží přesně na boku žebra)
        const onSide = (pin, pout, T) => {
          const dx = pout[0]-pin[0], dy = pout[1]-pin[1], a = dx*dx + dy*dy, b = 2*(pin[0]*dx + pin[1]*dy), c = pin[0]*pin[0] + pin[1]*pin[1] - T*T;
          const u = Math.min(0.999, Math.max(0.02, (-b + Math.sqrt(Math.max(0, b*b - 4*a*c)))/(2*a || 1)));
          return [pin[0] + dx*u, pin[1] + dy*u];
        };
        f.Aside = onSide(f.Ain, f.Aout, plateT[k].A); f.Bside = onSide(f.Bin, f.Bout, plateT[k].B);
      }
      out.push(f);
    }
    return {fins:out};
  }
  function arc(r1, a1, a2, count, r2){
    if (r2 === undefined) r2 = r1;
    while (a2 <= a1) a2 += TAU;
    const pts = [];
    for (let j=1;j<=count;j++){ const u = j/(count+1), a = a1+(a2-a1)*u, r = r1+(r2-r1)*u; pts.push([r*Math.cos(a), r*Math.sin(a)]); }
    return pts;
  }
  function gearRing(z){
    const {fins} = finsAt(z);
    const ids = [], tipA = [], tipB = [], inA = [], inB = [], sA = [], sB = [], arcs = [];
    for (let k=0;k<N;k++){
      const f = fins[k], nx = fins[(k+1)%N];
      inA.push(V(f.Ain[0],f.Ain[1],z)); ids.push(inA[k]);
      if (f.Aside){ sA.push(V(f.Aside[0],f.Aside[1],z)); ids.push(sA[k]); }
      tipA.push(V(f.Aout[0],f.Aout[1],z)); ids.push(tipA[k]);
      tipB.push(V(f.Bout[0],f.Bout[1],z)); ids.push(tipB[k]);
      if (f.Bside){ sB.push(V(f.Bside[0],f.Bside[1],z)); ids.push(sB[k]); }
      inB.push(V(f.Bin[0],f.Bin[1],z)); ids.push(inB[k]);
      const a = arc(d.Rt, ang(...f.Bin), ang(...nx.Ain), m).map(p => V(p[0],p[1],z));
      arcs.push(a); ids.push(...a);
    }
    return {ids, tipA, tipB, inA, inB, sA, sB, arcs};
  }
  function plateRing(z, reuse){
    // dno je „vmáčknuté“ mezi žebra: jeho okraj v každé výšce sleduje konce žeber, tvar žeber se nemění
    const zc = z;
    const {fins} = finsAt(zc);
    const ids = [], arcs = [], ins = !!plateT;
    for (let k=0;k<N;k++){
      const f = fins[k], nx = fins[(k+1)%N];
      if (ins) ids.push(reuse ? reuse.sA[k] : V(f.Aside[0],f.Aside[1],z));
      ids.push(reuse ? reuse.tipA[k] : V(f.Aout[0],f.Aout[1],z));
      ids.push(reuse ? reuse.tipB[k] : V(f.Bout[0],f.Bout[1],z));
      if (ins) ids.push(reuse ? reuse.sB[k] : V(f.Bside[0],f.Bside[1],z));
      // okraj podstavy mezi žebry: u zapuštěné podstavy od boku žebra k boku dalšího žebra o „zapuštění“ níž než konce žeber
      const from = ins ? f.Bside : f.Bout, to = ins ? nx.Aside : nx.Aout;
      let a;
      if (d.env){   // obrys podstavy přesně podle řezu koulemi (ne lineárně mezi konci žeber)
        const a1 = ang(...from); let a2 = ang(...to); while (a2 <= a1) a2 += TAU;
        const Rb = d.R(zc), cnt = Math.max(q, 12);
        a = [];
        // rovná stěna dna: v každém úhlu menší z obálek dole a nahoře (dno nikde nepřečnívá přes žebra)
        const R0 = d.R(0), RB = d.R(d.bp);
        for (let j=1;j<=cnt;j++){ const t = a1 + (a2-a1)*j/(cnt+1), r = Math.max(d.Rfloor, ins ? Math.min(d.env(0, t, R0), d.env(d.bp, t, RB)) : d.env(zc, t, Rb)); a.push(V(r*Math.cos(t), r*Math.sin(t), z)); }
      } else a = arc(Math.hypot(...from), ang(...from), ang(...to), q, Math.hypot(...to)).map(p => V(p[0],p[1],z));
      arcs.push(a); ids.push(...a);
    }
    return {ids, arcs};
  }
  function loft(r0, r1, inward){
    const n = r0.length;
    for (let i=0;i<n;i++){
      const a0=r0[i], b0=r0[(i+1)%n], a1=r1[i], b1=r1[(i+1)%n];
      if (inward) idx.push(a0,b1,b0, a0,a1,b1); else idx.push(a0,b0,b1, a0,b1,a1);
    }
  }
  function tri(a,b,c,up){
    const ax=pos[3*a], ay=pos[3*a+1];
    const cz=(pos[3*b]-ax)*(pos[3*c+1]-ay)-(pos[3*b+1]-ay)*(pos[3*c]-ax);
    if ((cz>0) === up) idx.push(a,b,c); else idx.push(a,c,b);
  }
  function cap(ids, holes, up){
    const v2 = i => new THREE.Vector2(pos[3*i], pos[3*i+1]);
    const all = ids.concat(...holes);
    const faces = THREE.ShapeUtils.triangulateShape(ids.map(v2), holes.map(h => h.map(v2)));
    // triangulace vrací trojúhelníky se stejným směrem obíhání → orientaci určíme jednou pro celou plochu
    // (i trojúhelníky s nulovou plochou, např. tři body na boku žebra, pak navazují správně)
    let sum = 0;
    for (const f of faces){ const a = all[f[0]], b = all[f[1]], c = all[f[2]]; sum += (pos[3*b]-pos[3*a])*(pos[3*c+1]-pos[3*a+1]) - (pos[3*b+1]-pos[3*a+1])*(pos[3*c]-pos[3*a]); }
    const keep = (sum > 0) === up;
    for (const f of faces){ const a = all[f[0]], b = all[f[1]], c = all[f[2]]; if (keep) idx.push(a,b,c); else idx.push(a,c,b); }
  }

  // spodní plocha (z = zb, směrem dolů) s případně vyřezaným logem; outer = obrys plochy, holes = díry v ní
  function bottomFace(outer, holes, zb, maxD){
    let rimMin = Infinity; for (const id of outer) rimMin = Math.min(rimMin, Math.hypot(pos[3*id], pos[3*id+1]));
    const LG = logoGeometry(rimMin);
    logoInfo = null;
    if (LG && maxD >= 0.2){
      const D = Math.max(0.2, Math.min(settings.LD, maxD));
      const z0 = LG.polys.map(p => p.map(q => V(q[0], q[1], zb)));
      const zD = LG.polys.map(p => p.map(q => V(q[0], q[1], zb + D)));
      const kids = i => LG.parent.map((pa, j) => pa === i ? j : -1).filter(j => j >= 0);
      // dno bez loga: obrys dna s dírami vnějších obrysů loga + „ostrůvky“ (liché vnoření) s jejich dírami
      cap(outer, holes.concat(LG.polys.map((p, i) => i).filter(i => LG.depth[i] === 0).map(i => z0[i])), false);
      LG.polys.forEach((p, i) => {
        if (LG.depth[i] % 2 === 1) cap(z0[i], kids(i).map(j => z0[j]), false);   // ostrůvek na úrovni dna
        else cap(zD[i], kids(i).map(j => zD[j]), false);                        // strop vyřezané kapsy
        loft(z0[i], zD[i], LG.depth[i] % 2 === 0);                              // stěna kapsy
      });
      logoInfo = {size: LG.size, depth: D, top: zb + D, clipped: LG.clipped, clippedD: D < settings.LD - 1e-6};
    } else {
      if (LG) logoInfo = {skipped: true};
      cap(outer, holes, false);
    }
  }

  // podstava: deska z = rz .. bp (bp = horní plocha podstavy, odtud žebra nahoru)
  // rovná (svislá) boční stěna dna: u každého boku žebra menší z poloměrů dole a nahoře desky
  // (CORE ne: tam okraj dna v každé výšce sleduje konce žeber / řez koulí)
  if (state.style !== "core"){
    const f0 = finsAt(0).fins, fb = finsAt(d.bp).fins, r = p => Math.hypot(p[0], p[1]);
    plateT = f0.map((f, k) => ({A: Math.min(r(f.Aout), r(fb[k].Aout)), B: Math.min(r(f.Bout), r(fb[k].Bout))}));
  }
  const G0 = gearRing(d.bp);
  let P1;
  if (d.rz > 0.01){
    // zapuštěné dno: žebra a stěna trubky jdou až na podložku, deska (a dno uvnitř trubky) je zvednutá o rz
    const copy = (G, z) => {
      const m = new Map(), n = id => { if (!m.has(id)) m.set(id, V(pos[3*id], pos[3*id+1], z)); return m.get(id); };
      return {ids:G.ids.map(n), tipA:G.tipA.map(n), tipB:G.tipB.map(n), inA:G.inA.map(n), inB:G.inB.map(n), arcs:G.arcs.map(a => a.map(n))};
    };
    const Gb = copy(G0, 0), Gr = copy(G0, d.rz);
    loft(Gb.ids, Gr.ids, false);                       // žebra a trubka zvenku od podložky po spodek desky
    const Pr = plateRing(d.rz, Gr); P1 = plateRing(d.bp, G0);
    loft(Pr.ids, P1.ids, false);                       // svislý okraj desky
    for (let k=0;k<N;k++){                             // spodek desky mezi žebry (zapuštěný strop)
      const k1 = (k+1)%N;
      cap([Gr.inB[k], Gr.tipB[k], ...Pr.arcs[k], Gr.tipA[k1], Gr.inA[k1], ...Gr.arcs[k].slice().reverse()], [], false);
    }
    // uvnitř trubky: stěna trubky stojí na podložce, dno uvnitř je zvednuté o rz (s logem)
    const M = 96, Cb = [], Cr = [], ri = d.rc;
    for (let j=0;j<M;j++){ const a = TAU*j/M, x = ri*Math.cos(a), y = ri*Math.sin(a); Cb.push(V(x,y,0)); Cr.push(V(x,y,d.rz)); }
    cap(Gb.ids, [Cb], false);                          // na podložce: konce žeber + mezikruží stěny trubky
    loft(Cb, Cr, true);                                // vnitřní stěna zapuštění v trubce
    bottomFace(Cr, [], d.rz, d.floorZ - d.rz - 0.4);   // zapuštěné dno uvnitř trubky
  } else {
    const P0 = plateRing(0, null); P1 = plateRing(d.bp, G0);
    loft(P0.ids, P1.ids, false);
    bottomFace(P0.ids, [], 0, Math.min(d.bp, d.floorZ) - 0.4);
  }
  // horní plocha podstavy mezi žebry
  for (let k=0;k<N;k++){
    const k1 = (k+1)%N;
    const poly = plateT
      ? [G0.inB[k], G0.sB[k], ...P1.arcs[k], G0.sA[k1], G0.inA[k1], ...G0.arcs[k].slice().reverse()]
      : [G0.inB[k], G0.tipB[k], ...P1.arcs[k], G0.tipA[k1], G0.inA[k1], ...G0.arcs[k].slice().reverse()];
    cap(poly, [], true);
  }
  // žebra + trubka
  // vrstvy sítě: rovnoměrně + přesně v bodech zlomu profilu (ostré hrany zůstanou ostré)
  const nLev = Math.max(80, Math.min(280, Math.round((d.H-d.bp)/1.1)));
  const zl = [];
  for (let i=1;i<=nLev;i++) zl.push(d.bp + (d.H-d.bp)*i/nLev);
  const brk = d.breaks.filter(z => z > d.bp + 0.2 && z < d.H - 0.2);
  let levels = zl.filter(z => !brk.some(b => Math.abs(b-z) < 0.25)).concat(brk).sort((a,b) => a-b);
  if (d.filZ.length){   // zaoblení horní hrany žeber: husté vrstvy po oblouku
    const zf = d.filZ.filter(z => z > d.bp + 0.2 && z < d.H - 0.05);
    if (zf.length) levels = levels.filter(z => z < zf[0] - 0.25 || z >= d.H - 1e-9).concat(zf).sort((a,b) => a-b);
  }
  if (d.env){
    // koule: kde se konec žebra mezi vrstvami změní víc než o 0,5 mm (u 200mm vázy), vrstvu dělíme (hladký řez místo schodů)
    const tips = z => finsAt(z).fins.map(f => f.R);
    const jump = (a, b) => { let m = 0; for (let k=0;k<a.length;k++) m = Math.max(m, Math.abs(a[k]-b[k])); return m; };
    // rozpočet vrstev: při hlubokých výřezech se hloubka dělení sníží, aby síť nebyla zbytečně obří
    const base = levels.map(z => [z, tips(z)]), r0 = tips(d.bp);
    for (let maxDepth = 5; maxDepth >= 1; maxDepth--){
      const fine = [];
      const refine = (za, ra, zb, rb, depth) => {
        if (depth >= maxDepth || zb - za < 0.04*d.s || jump(ra, rb) <= 0.5*d.s) return;
        const zm = (za + zb)/2, rm = tips(zm);
        refine(za, ra, zm, rm, depth+1); fine.push(zm); refine(zm, rm, zb, rb, depth+1);
      };
      let za = d.bp, ra = r0;
      for (const [zb, rb] of base){ refine(za, ra, zb, rb, 0); fine.push(zb); za = zb; ra = rb; if (fine.length > 900) break; }
      if (fine.length <= 900 || maxDepth === 1){ if (fine.length <= 900) levels = fine; break; }
    }
  }
  let prev = G0;
  for (const z of levels){
    const g = gearRing(z);
    loft(prev.ids, g.ids, false);
    prev = g;
  }
  // dutina
  const M = 96, cav0 = [], cav1 = [];
  for (let j=0;j<M;j++){ const a=TAU*j/M, x=d.rc*Math.cos(a), y=d.rc*Math.sin(a); cav0.push(V(x,y,d.floorZ)); cav1.push(V(x,y,d.H)); }
  loft(cav0, cav1, true);
  const cf = V(0,0,d.floorZ);
  for (let j=0;j<M;j++) tri(cf, cav0[j], cav0[(j+1)%M], true);
  // horní hrana
  cap(prev.ids, [cav1.slice()], true);

  // plochy zapuštěného dna a loga jsou malá přemostění u podložky – do převisů se nepočítají
  return {pos:new Float32Array(pos), idx:new Uint32Array(idx), logoZ: Math.max(d.rz > 0.01 ? d.rz : 0, logoInfo && logoInfo.top ? logoInfo.top : 0)};
}

/* ---------- Analýza: převisy, objem, rozměry ---------- */
function analyze(mesh, thrDeg){
  const p = mesh.pos, I = mesh.idx, T = I.length/3;
  const fn = new Float32Array(T*3), area = new Float32Array(T), beta = new Float32Array(T);
  let vol = 0, areaTot = 0, areaBad = 0, maxBeta = 0, rmax = 0;
  const thr = (thrDeg + OV_TOL)*Math.PI/180;
  for (let t=0;t<T;t++){
    const a=I[3*t]*3, b=I[3*t+1]*3, c=I[3*t+2]*3;
    const ux=p[b]-p[a], uy=p[b+1]-p[a+1], uz=p[b+2]-p[a+2];
    const vx=p[c]-p[a], vy=p[c+1]-p[a+1], vz=p[c+2]-p[a+2];
    let nx=uy*vz-uz*vy, ny=uz*vx-ux*vz, nz=ux*vy-uy*vx;
    const L=Math.hypot(nx,ny,nz)||1; area[t]=L/2; nx/=L; ny/=L; nz/=L;
    fn[3*t]=nx; fn[3*t+1]=ny; fn[3*t+2]=nz;
    vol += (p[a]*(p[b+1]*p[c+2]-p[b+2]*p[c+1]) - p[a+1]*(p[b]*p[c+2]-p[b+2]*p[c]) + p[a+2]*(p[b]*p[c+1]-p[b+1]*p[c]))/6;
    const lz = (mesh.logoZ || 0) + 0.01;   // vyřezané logo ve dně se nepočítá do převisů (malé přemostění)
    const onBed = p[a+2]<lz && p[b+2]<lz && p[c+2]<lz;
    const sliver = area[t] < 1e-3;   // téměř nulová plocha (body v přímce) – směr nejde určit, nepočítat
    const bt = (!onBed && !sliver && nz<0) ? Math.asin(Math.min(1,-nz)) : 0;
    beta[t] = bt;
    if (!onBed){ areaTot += area[t]; if (bt>thr) areaBad += area[t]; if (bt>maxBeta) maxBeta = bt; }
  }
  for (let i=0;i<p.length;i+=3) rmax = Math.max(rmax, Math.hypot(p[i],p[i+1]));
  return {fn, area, beta, vol, overPct: areaTot ? 100*areaBad/areaTot : 0, maxBeta: maxBeta*180/Math.PI, rmax};
}



/* ================= Zákaznický konfigurátor ================= */
const CFG = window.VAZOVNA_SHOP || {
  // napojení na Shopify: v obchodě to doplní sekce šablony (varianty, měna, adresa košíku)
  demo: true,
  products: {wave:"WAVE VASE", spiral:"SPIRAL VASE", zigzag:"ZIGZAG VASE"},
  magicProducts: {wave:"WAVE VASE MAGIC", spiral:"SPIRAL VASE MAGIC", zigzag:"ZIGZAG VASE MAGIC"},
  prices: {150:990, 200:1590, 300:3790}, magicPrices: {150:1090, 200:1690, 300:3890}, currency:"CZK",
  variants: null
};
const SIZES = [150, 200, 300];
// logo Martin Žampach (obrysy z mz_logo_big.png, viz trace-logo.js)
const LOGO = {name:"martin zampach", loops:[[0.131,-0.1889,0.1444,-0.1898,0.1524,-0.1836,0.1533,-0.1613,0.2014,-0.1613,0.2077,-0.1569,0.2077,-0.139,0.2059,-0.1355,0.2014,-0.1328,0.1524,-0.1319,0.1524,-0.0695,0.1586,-0.0579,0.1711,-0.0526,0.1818,-0.0561,0.1898,-0.066,0.1898,-0.0784,0.1961,-0.0865,0.2139,-0.0865,0.2184,-0.082,0.2201,-0.0713,0.2184,-0.0695,0.2184,-0.0606,0.213,-0.0481,0.1996,-0.033,0.1907,-0.0276,0.1783,-0.0241,0.1658,-0.0241,0.1533,-0.0276,0.1364,-0.0392,0.1257,-0.057,0.1257,-0.0642,0.1239,-0.066,0.1239,-0.1319,0.107,-0.1328,0.1025,-0.1373,0.1007,-0.1515,0.1025,-0.1569,0.107,-0.1613,0.1239,-0.1622,0.1239,-0.1836],[-0.3307,-0.1693,-0.3191,-0.1702,-0.2995,-0.1631,-0.2906,-0.1684,-0.2727,-0.1702,-0.2567,-0.1649,-0.2451,-0.1533,-0.2398,-0.1426,-0.2398,-0.0321,-0.2442,-0.0276,-0.262,-0.0276,-0.2656,-0.0294,-0.2683,-0.0339,-0.2683,-0.1355,-0.2745,-0.1417,-0.2799,-0.1417,-0.2861,-0.1373,-0.2861,-0.0339,-0.2923,-0.0276,-0.3102,-0.0276,-0.3146,-0.0321,-0.3146,-0.1337,-0.3164,-0.1373,-0.3226,-0.1417,-0.3298,-0.1399,-0.3342,-0.1337,-0.3342,-0.0321,-0.3387,-0.0276,-0.3565,-0.0276,-0.3627,-0.0339,-0.3627,-0.1604,-0.361,-0.164,-0.3565,-0.1667,-0.3387,-0.1667],[-0.1578,-0.1693,-0.1444,-0.1702,-0.1426,-0.1684,-0.1337,-0.1684,-0.1194,-0.1613,-0.1078,-0.1497,-0.1043,-0.1426,-0.1007,-0.1301,-0.1007,-0.057,-0.0963,-0.0561,-0.09,-0.0499,-0.09,-0.0339,-0.0918,-0.0303,-0.0963,-0.0276,-0.1123,-0.0276,-0.123,-0.0348,-0.1355,-0.0276,-0.148,-0.0241,-0.1676,-0.0241,-0.1854,-0.0312,-0.197,-0.0428,-0.2005,-0.0499,-0.2005,-0.0553,-0.2023,-0.057,-0.2023,-0.0784,-0.1952,-0.0927,-0.1872,-0.1007,-0.1693,-0.1096,-0.139,-0.1168,-0.131,-0.123,-0.131,-0.1319,-0.1355,-0.1381,-0.1462,-0.1417,-0.1551,-0.1417,-0.1622,-0.1381,-0.1684,-0.1319,-0.1702,-0.1212,-0.1765,-0.1132,-0.1925,-0.1132,-0.1988,-0.1176,-0.1988,-0.1337,-0.1898,-0.1515,-0.18,-0.1613,-0.1658,-0.1684],[0.0116,-0.1693,0.0267,-0.1702,0.0285,-0.1684,0.0374,-0.1684,0.0481,-0.1631,0.0633,-0.148,0.0686,-0.1355,0.0686,-0.1301,0.0704,-0.1283,0.0704,-0.0998,0.0624,-0.0936,0.0481,-0.0936,0.0437,-0.0963,0.0419,-0.0998,0.0419,-0.123,0.0401,-0.1248,0.0401,-0.1301,0.0303,-0.1399,0.025,-0.1417,0.0089,-0.1399,-0.0009,-0.1301,-0.0009,-0.1248,-0.0027,-0.123,-0.0027,-0.057,0.041,-0.0561,0.0472,-0.0517,0.0472,-0.0321,0.0428,-0.0276,-0.0481,-0.0276,-0.0526,-0.0321,-0.0526,-0.0517,-0.0463,-0.0561,-0.0312,-0.057,-0.0312,-0.1283,-0.0276,-0.1408,-0.0241,-0.148,-0.0089,-0.1631,0.0036,-0.1684],[0.4412,-0.1693,0.4581,-0.1702,0.4759,-0.1649,0.4929,-0.1497,0.4982,-0.139,0.4982,-0.1337,0.5,-0.1319,0.5,-0.0321,0.4955,-0.0276,0.4777,-0.0276,0.4715,-0.0339,0.4715,-0.1283,0.4635,-0.1381,0.4563,-0.1417,0.4456,-0.1417,0.4367,-0.1381,0.4287,-0.1266,0.4287,-0.0339,0.4269,-0.0303,0.4225,-0.0276,0.4046,-0.0276,0.4002,-0.0321,0.4002,-0.1622,0.4046,-0.1667,0.4225,-0.1667,0.4278,-0.1649,0.4332,-0.1684],[0.2665,-0.1658,0.3244,-0.1667,0.3289,-0.1622,0.3289,-0.057,0.3619,-0.0561,0.3654,-0.0544,0.3681,-0.0499,0.3681,-0.0321,0.3636,-0.0276,0.2567,-0.0276,0.2522,-0.0303,0.2504,-0.0339,0.2504,-0.0499,0.2567,-0.0561,0.3004,-0.057,0.3004,-0.1373,0.2674,-0.1381,0.2611,-0.1462,0.2611,-0.1604],[-0.1328,-0.0945,-0.131,-0.0945,-0.131,-0.066,-0.1328,-0.0624,-0.1444,-0.0544,-0.1515,-0.0544,-0.1533,-0.0526,-0.1676,-0.0544,-0.1738,-0.0624,-0.172,-0.0766,-0.1658,-0.0829,-0.1586,-0.0865,-0.148,-0.0882],[-0.4929,-0.0553,-0.4029,-0.0561,-0.3993,-0.0544,-0.3966,-0.0499,-0.3966,-0.0339,-0.3984,-0.0303,-0.4029,-0.0276,-0.492,-0.0276,-0.4982,-0.0357,-0.4982,-0.0481],[0.4055,-0.0107,0.4225,-0.0116,0.4287,-0.0053,0.4296,0.0205,0.4385,0.0169,0.4617,0.0169,0.4635,0.0187,0.4688,0.0187,0.4795,0.0241,0.4929,0.0374,0.5,0.0535,0.5,0.1551,0.4973,0.1578,0.4938,0.1595,0.4795,0.1595,0.4759,0.1578,0.4715,0.1515,0.4715,0.0588,0.4697,0.0553,0.4581,0.0455,0.4421,0.0455,0.4385,0.0472,0.4287,0.0588,0.4287,0.1515,0.4269,0.1551,0.4225,0.1595,0.4064,0.1595,0.402,0.1569,0.4002,0.1533,0.4002,-0.0071],[-0.3164,0.0178,-0.2941,0.0169,-0.2923,0.0187,-0.287,0.0187,-0.2709,0.0276,-0.2594,0.0428,-0.2558,0.0553,-0.2558,0.1283,-0.2451,0.1355,-0.2451,0.1533,-0.2469,0.1569,-0.2513,0.1595,-0.2638,0.1595,-0.2781,0.1524,-0.2977,0.1613,-0.3084,0.1613,-0.3102,0.1631,-0.3262,0.1613,-0.3387,0.156,-0.3538,0.139,-0.3556,0.1266,-0.3574,0.1248,-0.3574,0.1141,-0.352,0.0963,-0.3369,0.0829,-0.3209,0.0758,-0.2959,0.0704,-0.2888,0.0668,-0.2843,0.0606,-0.2861,0.0535,-0.2923,0.0472,-0.2959,0.0455,-0.3102,0.0455,-0.3155,0.0472,-0.3235,0.0553,-0.3253,0.0677,-0.3298,0.0722,-0.3333,0.074,-0.3458,0.074,-0.3538,0.0677,-0.3538,0.0553,-0.3467,0.0374,-0.3333,0.0241,-0.3226,0.0187],[-0.1809,0.0178,-0.1604,0.0169,-0.1462,0.0241,-0.1319,0.0169,-0.1141,0.0169,-0.0963,0.0258,-0.09,0.0339,-0.0847,0.0481,-0.0847,0.1515,-0.0909,0.1595,-0.107,0.1595,-0.1105,0.1578,-0.1132,0.1533,-0.1132,0.0517,-0.115,0.0481,-0.1194,0.0455,-0.1266,0.0455,-0.1328,0.0535,-0.1328,0.1551,-0.139,0.1595,-0.1551,0.1595,-0.1613,0.1515,-0.1613,0.0499,-0.1658,0.0455,-0.1747,0.0455,-0.1791,0.0517,-0.1791,0.1533,-0.1854,0.1595,-0.2014,0.1595,-0.2059,0.1569,-0.2077,0.1533,-0.2077,0.025,-0.1996,0.0187],[-0.0045,0.0178,0.0196,0.0169,0.0214,0.0187,0.0267,0.0187,0.0446,0.0294,0.0526,0.0392,0.0597,0.0606,0.0597,0.1176,0.0526,0.139,0.041,0.1524,0.0285,0.1595,0.0125,0.1613,0.0107,0.1631,-0.0053,0.1613,-0.0125,0.1578,-0.0134,0.1836,-0.0152,0.1872,-0.0196,0.1898,-0.0357,0.1898,-0.0392,0.1881,-0.0419,0.1836,-0.0419,0.025,-0.0339,0.0187,-0.0214,0.0187,-0.016,0.0223,-0.0107,0.0187],[0.1453,0.0178,0.1676,0.0169,0.1854,0.0241,0.197,0.0339,0.2041,0.0481,0.2041,0.0535,0.2059,0.0553,0.2059,0.1283,0.2086,0.131,0.2121,0.131,0.2166,0.1373,0.2166,0.1533,0.2103,0.1595,0.1979,0.1595,0.1889,0.156,0.1854,0.1524,0.1818,0.1524,0.1783,0.156,0.1622,0.1613,0.1533,0.1613,0.1515,0.1631,0.1355,0.1613,0.1194,0.1542,0.1132,0.148,0.1061,0.1355,0.1043,0.1301,0.1043,0.1087,0.1096,0.0963,0.1194,0.0865,0.1319,0.0793,0.1658,0.0704,0.1756,0.0642,0.1756,0.0535,0.1693,0.0472,0.164,0.0455,0.1497,0.0455,0.1381,0.0553,0.1364,0.066,0.1319,0.0722,0.1159,0.074,0.1078,0.0677,0.1078,0.0535,0.115,0.0374,0.1283,0.0241,0.139,0.0187],[0.2968,0.0178,0.3226,0.0169,0.3387,0.0241,0.3458,0.0294,0.352,0.0374,0.3592,0.0517,0.3592,0.0677,0.3512,0.074,0.3351,0.0722,0.3307,0.066,0.3307,0.0588,0.3271,0.0517,0.3173,0.0455,0.3012,0.0455,0.2977,0.0472,0.2879,0.0588,0.2879,0.1194,0.2995,0.1328,0.3191,0.1328,0.3244,0.1292,0.3289,0.1248,0.3324,0.1087,0.3405,0.1043,0.3512,0.1043,0.3592,0.1105,0.3592,0.1266,0.3503,0.1444,0.3422,0.1524,0.3298,0.1595,0.3137,0.1613,0.3119,0.1631,0.2959,0.1613,0.2799,0.1542,0.2665,0.1408,0.2594,0.123,0.2594,0.0553,0.2611,0.0535,0.2611,0.0481,0.2665,0.0374,0.2799,0.0241,0.2906,0.0187],[-0.4893,0.0196,-0.4082,0.0187,-0.4002,0.025,-0.4002,0.0446,-0.402,0.0481,-0.4608,0.1301,-0.3993,0.131,-0.393,0.139,-0.393,0.1515,-0.3975,0.1578,-0.4011,0.1595,-0.4938,0.1595,-0.4982,0.1569,-0.5,0.1533,-0.5,0.1337,-0.4376,0.0499,-0.4902,0.049,-0.4938,0.0472,-0.4982,0.0392,-0.4982,0.0285,-0.4964,0.0232],[-0.0009,0.0463,0.016,0.0455,0.0294,0.057,0.0294,0.1212,0.0258,0.1266,0.0178,0.1328,0,0.1328,-0.0098,0.1248,-0.0134,0.1176,-0.0134,0.0606,-0.0098,0.0535],[-0.2879,0.0927,-0.2843,0.0927,-0.2843,0.1176,-0.2879,0.1248,-0.3012,0.1328,-0.3209,0.1328,-0.3271,0.1266,-0.3289,0.1212,-0.3271,0.1105,-0.3209,0.1043,-0.3102,0.0989,-0.3048,0.0989],[0.1738,0.0927,0.1756,0.0927,0.1756,0.1212,0.1676,0.1292,0.1604,0.1328,0.1408,0.1328,0.1328,0.123,0.1346,0.1105,0.1462,0.1007,0.1693,0.0954]]};
const SIZE_NOZZLE = {150:0.4, 200:0.4, 300:0.6};
// barvy filamentů = volba Color v obchodě (swatche z produktů)
const FILAMENTS = [["Hunter Green","#449f4d"],["Turquoise","#0098a7"],["Fresh Meadow","#9FE0C3"],["Gentle Breeze","#BEE0E9"],["Maya Blue","#52C5EF"],["Just Blue","#004ac6"],["Just Purple","#744DEA"],["Bright Violet","#d0a1fa"],["Gentle Blossom","#FFC0CB"],["Sangria Red","#be4a38"],["Just Red","#F61F1F"],["Pumpkin Orange","#FF8A00"],["Just Yellow","#FFE500"],["Caramel","#c79753"],["Creamy Coffee","#EAD8AB"],["Just White","#fafafa"],["Elephant Gray","#808080"],["Just Black","#000000"]];
// bezpečné rozsahy úprav (ověřeno: převis nepřekročí 45° ani převis originálu, žebro nesjede z trubky)
const SPIRAL_MAX = {"SPIRAL-01":270, "SPIRAL-02":270, "SPIRAL-03":270, "SPIRAL-04":270};   // max. 0,75 otáčky (originál)
const CUSTOM = {
  wave:   [{k:"N", min:15, max:25, step:1, label:"ribs"}, {k:"A", min:0, max:5, step:0.1, label:"waveDepth"}],
  spiral: [{k:"N", min:15, max:25, step:1, label:"ribs"}, {k:"T", min:0, max:p => SPIRAL_MAX[p], step:5, label:"twist"}],
  zigzag: [{k:"N", min:15, max:25, step:1, label:"ribs"}, {k:"ZN", min:0, max:40, step:0.5, label:"toothAngle"}]
};

const I18N = {
  en: {eyebrow:"Configurator", title:"Design your own vase", lead:"Pick a collection and a shape, then fine-tune the ribs.",
    collection:"Select Collection", shape:"Select Shape", size:"Select Size", color:"Select Color", custom:"Customize", crumbHome:"Home", yourDesign:"Your design", magic:"PLA MAGIC – double color material", rpla:"rPLA – recycled material", reset:"Back to the original design",
    ribs:"Ribs", waveDepth:"Wave depth", twist:"Twist", toothAngle:"Tooth angle", turn:"turn", turns:"turns", none:"none",
    vat:"incl. VAT", addToCart:"Add to cart", hintDrag:"Drag to rotate · zoom in to see the print layers", bottomView:"View bottom", sideView:"View side",
    specCollection:"Collection", specShape:"Shape", specSize:"Size", specColor:"Color", specCustom:"Custom", original:"Original design",
    demoNote:"Preview only: in the store this button adds the variant below to the cart, with the custom settings attached to the order.",
    cartOk:"Added to cart.", cartErr:"Could not add to cart. Please try again.", building:"Updating…"},
  cs: {eyebrow:"Konfigurátor", title:"Navrhni si vlastní vázu", lead:"Vyber kolekci a tvar a dolaď žebra.",
    collection:"Vyber kolekci", shape:"Vyber tvar", size:"Vyber velikost", color:"Vyber barvu", custom:"Úpravy", crumbHome:"Domů", yourDesign:"Tvůj návrh", magic:"PLA MAGIC – dvoubarevný materiál", rpla:"rPLA – recyklovaný materiál", reset:"Zpět na originální návrh",
    ribs:"Počet žeber", waveDepth:"Hloubka vlny", twist:"Stočení", toothAngle:"Náklon zubu", turn:"otáčky", turns:"otáčky", none:"bez stočení",
    vat:"vč. DPH", addToCart:"Přidat do košíku", hintDrag:"Táhni pro otočení · přibliž si vrstvy tisku", bottomView:"Pohled zespodu", sideView:"Pohled z boku",
    specCollection:"Kolekce", specShape:"Tvar", specSize:"Velikost", specColor:"Barva", specCustom:"Úpravy", original:"Originální návrh",
    demoNote:"Ukázka: v obchodě tlačítko vloží do košíku variantu níže a k objednávce připojí nastavené úpravy.",
    cartOk:"Přidáno do košíku.", cartErr:"Do košíku se nepodařilo přidat. Zkus to prosím znovu.", building:"Přepočítávám…"}
};
let lang = CFG.lang ? (String(CFG.lang).toLowerCase().startsWith("cs") ? "cs" : "en") : (document.documentElement.lang || navigator.language || "en").toLowerCase().startsWith("cs") ? "cs" : "en";
const t = k => I18N[lang][k] ?? k;
const $ = id => document.getElementById(id);
const nf = (v, d=0) => v.toLocaleString(lang === "cs" ? "cs-CZ" : "en-GB", {minimumFractionDigits:d, maximumFractionDigits:d});

// MAGIC = dvou/tříbarevný filament: každá strana vázy má jinou barvu, mezi nimi plynulý přechod
const MC = {PINK:"#EE6FD2", YELLOW:"#F1E25C", GREEN:"#3FB86B", BLUE:"#3F82E0", PURPLE:"#8A52D8", RED:"#D9363E", BRONZE:"#C99B6B", TURQUOISE:"#2EC3C6"};
// váha barev v přechodu (výchozí 1:1) a odstíny konkrétních kombinací podle fotek z obchodu
// GREEN-YELLOW: zelená převládá na 2/3 obvodu (hranice při cos = −0,5 → váha žluté (1/3)^0,8 ≈ 0,415)
// GREEN-BLUE: geometricky 1:1 vypadal zeleně (zelená je světlejší) → modrá dostane ~58 % obvodu, aby na pohled vyšlo 1:1
const MAGIC_BIAS = {"GREEN-YELLOW":[1, 0.415], "GREEN-BLUE":[1, 1.5], "GREEN-RED":[1, 0.6]};
const MAGIC_TONES = {"GREEN-YELLOW":["#3FB86B", "#D6E23C"], "GREEN-BLUE":["#3FB86B", "#2C66C0"], "GREEN-RED":["#006E29", "#B5242C"]};   // tmavší modrá / tmavší červená   // GREEN-BLUE: tmavší modrá   // zelená jako dřív, limetkově žlutá podle fotky
const MAGIC = ["PINK-YELLOW","GREEN-YELLOW","GREEN-BLUE","GREEN-RED","PURPLE-TURQUOISE","BRONZE-BLUE"]
  .map(n => [n, null, MAGIC_TONES[n] || n.split("-").map(c => MC[c])]);
const isMagic = c => !!c[2];
const swatchBg = c => !isMagic(c) ? c[1] : c[2].length === 2 ? "linear-gradient(135deg," + c[2][0] + (MAGIC_BIAS[c[0]] && MAGIC_BIAS[c[0]][1] < 1 ? " 45%" : "") + "," + c[2][1] + ")"
  : "conic-gradient(from 90deg," + c[2][0] + "," + c[2][1] + "," + c[2][2] + "," + c[2][0] + ")";
const pick = {style:"wave", preset:"WAVE-01", H:200, color:MAGIC.find(c => c[0] === "PURPLE-TURQUOISE"), custom:{}};
const shapeNo = p => p.split("-").pop();
const label = p => p.replace("-", " ");

function originalOf(style, preset){ const st = presetState(style, preset); const o = {}; for (const c of CUSTOM[style]) o[c.k] = st[c.k]; return o; }
function rangeMax(c){ return typeof c.max === "function" ? c.max(pick.preset) : c.max; }
function applySelection(){
  state = presetState(pick.style, pick.preset);
  state.H = pick.H;
  for (const c of CUSTOM[pick.style]) if (pick.custom[c.k] !== undefined) state[c.k] = Math.min(rangeMax(c), Math.max(c.min, pick.custom[c.k]));
  settings.nozzle = SIZE_NOZZLE[pick.H]; settings.M = +(settings.nozzle*2).toFixed(2); settings.keepMin = true;
  settings.logo = LOGO; settings.LS = 30; settings.LD = 0.8; settings.LR = 0;   // logo vygravírované do dna (30 mm u 20cm vázy)
}
function isOriginal(){
  const o = originalOf(pick.style, pick.preset);
  return CUSTOM[pick.style].every(c => pick.custom[c.k] === undefined || Math.abs(pick.custom[c.k] - o[c.k]) < 1e-6);
}
function fmtCustom(k, v){
  if (k === "N") return nf(v);
  if (k === "A") return nf(v*pick.H/200, 1) + " mm";
  if (k === "T") return v === 0 ? t("none") : nf(v/360, 2) + " " + t("turns");
  if (k === "ZN") return nf(v, 1) + "°";
  return String(v);
}

/* ---------- 3D náhled ---------- */
let renderer, scene, camera, controls, mesh, shadow, ground, idleT = 0;
// otočný talíř: scéna (kamera, světla, stín) stojí, otáčí se jen váza
let spin = true, lockAz = 0;
// výchozí pohled (o 30° pootočený doprava, aby byl celý stín vidět)
const camHome = () => new THREE.Vector3(400, -545, 250).applyAxisAngle(new THREE.Vector3(0, 0, 1), 30*Math.PI/180);
const pauseSpin = () => { spin = false; clearTimeout(idleT); };
const resumeSpin = () => { clearTimeout(idleT); idleT = setTimeout(() => { if (!bottomOn) spin = true; }, 6000); };
const turnVase = a => { if (mesh) mesh.rotation.z += a; };
const stage = $("stage"), glc = $("gl");
// prostředí studia pro odlesky: šedá místnost se softboxy (osa z nahoru)
function studioEnv(){
  const pm = new THREE.PMREMGenerator(renderer), env = new THREE.Scene();
  env.add(new THREE.Mesh(new THREE.BoxGeometry(12,12,12), new THREE.MeshBasicMaterial({color:0x2e2e2c, side:THREE.BackSide})));
  const panel = (w, h, x, y, z, i) => {
    const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({color:new THREE.Color(i, i, i), side:THREE.DoubleSide}));
    m.position.set(x, y, z); m.lookAt(0, 0, 0); env.add(m);
  };
  panel(5.5, 6,  3.2, -4.2, 2.4, 2.2);    // hlavní softbox vpředu vpravo (velký a slabší = měkký odraz na bocích žeber)
  panel(2.2, 5,   -4.8,  0.6, 1.2, 1.6);  // protisvětlo vlevo
  panel(7, 1.4,    0,    5.2, 3.2, 1.6);    // pruh vzadu (obrysové světlo)
  panel(9, 9,      0,    0,   5.8, 0.9);  // strop
  panel(6, 6,      1.5, -1.5, -5.8, 0.8); // světlá podlaha (pohled zespodu na logo)
  const rt = pm.fromScene(env, 0.035);
  pm.dispose();
  return rt.texture;
}
// vrstvy tisku: drobné vodorovné „housenky“ přímo ve stínování (síť se nemění);
// když je vrstva menší než pixel, plynule zmizí (jinak by vzniklo moaré) – vidět jsou při přiblížení
const layerH = {value:0.2};
function addLayerLines(mat){
  const layers = renderer.capabilities.isWebGL2;   // dFdx jen ve WebGL2
  mat.onBeforeCompile = sh => {
    sh.uniforms.layerH = layerH;
    sh.vertexShader = sh.vertexShader
      .replace("#include <common>", "#include <common>\nvarying float vLz;\nattribute float ao;\nvarying float vAO;")
      .replace("#include <begin_vertex>", "#include <begin_vertex>\nvLz = position.z;\nvAO = ao;");
    sh.fragmentShader = sh.fragmentShader
      .replace("#include <common>", "#include <common>\nvarying float vLz;\nuniform float layerH;\nvarying float vAO;")
      // stínování v mezerách mezi žebry: tlumí světlo i odlesky prostředí, přímé světlo jen částečně
      .replace("#include <aomap_fragment>", "reflectedLight.indirectDiffuse *= vAO;\nreflectedLight.indirectSpecular *= vAO * vAO;")
      .replace("#include <normal_fragment_maps>", `#include <normal_fragment_maps>
      diffuseColor.rgb *= mix(1.0, vAO, 0.55);
      if (${layers ? "true" : "false"}) {
        // hladká vlna místo zubu (bez vyšších harmonických → bez moaré); úplně zmizí před Nyquistem (pixel = půl vrstvy)
        float u = vLz / layerH;
        float fw = length(vec2(dFdx(u), dFdy(u)));
        float fade = clamp(1.0 - fw * 2.2, 0.0, 1.0); fade *= fade;
        float c = cos(6.2831853 * u);
        vec3 upV = normalize((viewMatrix * vec4(0.0, 0.0, 1.0, 0.0)).xyz);
        normal = normalize(normal + upV * sin(6.2831853 * u) * 0.35 * fade);
        diffuseColor.rgb *= 1.0 - 0.05 * fade * (0.5 - 0.5 * c);
      }`)
      // hedvábný lesk (silk PLA): vlákna vrstev běží vodorovně → anizotropní odlesk (Kajiya-Kay) vytvoří svislý satinový pruh
      .replace("#include <output_fragment>", `{
        vec3 V = normalize(vViewPosition);
        vec3 upV = normalize((viewMatrix * vec4(0.0, 0.0, 1.0, 0.0)).xyz);
        vec3 T = normalize(cross(upV, normal) + 1e-5);
        vec3 tint = mix(vec3(1.0), diffuseColor.rgb, 0.45);
        float silk = 0.0;
        #if NUM_DIR_LIGHTS > 0
          vec3 L = directionalLights[0].direction;
          vec3 Hk = normalize(L + V); float tk = dot(T, Hk);
          silk += pow(max(0.0, 1.0 - tk*tk), 140.0) * 0.28 * clamp(dot(normal, L) * 0.6 + 0.4, 0.0, 1.0);
        #endif
        float tv = dot(T, V);
        silk += pow(max(0.0, 1.0 - tv*tv), 70.0) * 0.05;          // měkký pruh proti pohledu (světlo ze studia za kamerou)
        float rim = vAO * vAO * vAO * vAO;   // hlavně vnější hrany žeber, v mezerách skoro nic
        outgoingLight += tint * silk * rim;
      }
      #include <output_fragment>`);
  };
}
// mobil: OrbitControls by blokoval rolování stránky – vlastní ovládání prstem
function setupTouch(){
  controls.enableRotate = false; controls.enableZoom = false;
  glc.style.touchAction = "pan-y";
  let x0 = 0, d0 = 0, mode = null;
  const dist = e => Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
  const pause = pauseSpin, resume = resumeSpin;
  glc.addEventListener("touchstart", e => {
    pause();
    if (e.touches.length === 1){ x0 = e.touches[0].clientX; mode = "rot"; }
    else if (e.touches.length === 2){ d0 = dist(e); mode = "zoom"; }
  }, {passive:true});
  glc.addEventListener("touchmove", e => {
    const off = camera.position.clone().sub(controls.target);
    if (mode === "rot" && e.touches.length === 1){
      const x = e.touches[0].clientX; turnVase((x - x0)*0.012); x0 = x; return;
    } else if (mode === "zoom" && e.touches.length === 2){
      e.preventDefault();
      const d = dist(e), L = Math.min(controls.maxDistance, Math.max(controls.minDistance, off.length()*d0/d)); d0 = d;
      off.setLength(L);
    } else return;
    camera.position.copy(controls.target).add(off);
  }, {passive:false});
  glc.addEventListener("touchend", e => { if (!e.touches.length){ mode = null; resume(); } }, {passive:true});
}
function initGL(){
  if (!window.THREE) return false;
  renderer = new THREE.WebGLRenderer({canvas:glc, antialias:true, alpha:true});
  renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
  renderer.outputEncoding = THREE.sRGBEncoding;
  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera(28, 1, 1, 6000);
  camera.up.set(0,0,1);
  controls = new THREE.OrbitControls(camera, glc);
  controls.enableDamping = true; controls.dampingFactor = 0.08; controls.enablePan = false;
  controls.minDistance = 55; controls.maxDistance = 1800;
  controls.minPolarAngle = Math.PI*0.12; controls.maxPolarAngle = Math.PI*0.58;   // zespodu jen přes tlačítko „pohled zespodu“
  controls.rotateSpeed = 0.6;
  controls.autoRotate = false;
  controls.addEventListener("start", pauseSpin);
  controls.addEventListener("end", resumeSpin);
  if (matchMedia("(pointer: coarse)").matches) setupTouch();
  else {   // myš: tah do stran otáčí vázou (kamera má zamčený vodorovný úhel), nahoru/dolů mění úhel pohledu
    let px = null;
    glc.addEventListener("pointerdown", e => { if (e.button === 0){ px = e.clientX; pauseSpin(); } });
    window.addEventListener("pointermove", e => { if (px !== null){ turnVase((e.clientX - px)*0.01); px = e.clientX; } });
    window.addEventListener("pointerup", () => { if (px !== null){ px = null; resumeSpin(); } });
  }
  renderer.toneMapping = THREE.NoToneMapping;   // ACES barvy vybledí – bez tone mappingu zůstanou syté
  scene.environment = studioEnv();
  const k = new THREE.DirectionalLight(0xffffff, 0.9); k.position.set(260,-380,620); scene.add(k);
  // skutečný měkký stín od hlavního světla na neviditelné podložce (pozadí zůstane bílé);
  // světlo i váza stojí, takže se stín přepočítá jen po změně vázy
  renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFShadowMap; renderer.shadowMap.autoUpdate = false;
  // stín s proměnnou neostrostí (PCSS): u paty vázy ostrý, čím dál od vázy (výš položené části), tím rozmazanější
  if (!THREE.ShaderChunk.shadowmap_pars_fragment.includes("vzPCSS")){
    const pcss = `
      float vzPCSS(sampler2D sm, vec4 sc){
        float zR = sc.z, sum = 0.0, n = 0.0;
        for (int i = 0; i < 16; i++){
          float a = float(i) * 2.39996, r = sqrt((float(i) + 0.5) / 16.0);
          float d = unpackRGBAToDepth(texture2D(sm, sc.xy + vec2(cos(a), sin(a)) * r * 0.035));
          if (d < zR){ sum += d; n += 1.0; }
        }
        if (n < 0.5) return 1.0;
        float pen = clamp((zR - sum / n) * 0.22, 0.0012, 0.045);   // šířka rozmazání v UV podle vzdálenosti vrhající části
        float lit = 0.0;
        for (int i = 0; i < 24; i++){
          float a = float(i) * 2.39996 + 0.7, r = sqrt((float(i) + 0.5) / 24.0);
          lit += step(zR, unpackRGBAToDepth(texture2D(sm, sc.xy + vec2(cos(a), sin(a)) * r * pen)));
        }
        return lit / 24.0;
      }`;
    THREE.ShaderChunk.shadowmap_pars_fragment = THREE.ShaderChunk.shadowmap_pars_fragment
      .replace("#ifdef USE_SHADOWMAP", "#ifdef USE_SHADOWMAP" + pcss)
      .replace("#if defined( SHADOWMAP_TYPE_PCF )", "return vzPCSS( shadowMap, shadowCoord );\n#if defined( SHADOWMAP_TYPE_PCF )");
  }
  // stín vrhá samostatné (téměř nesvítící) světlo ze strany, aby stín dopadl šikmo vedle vázy a nezměnily se odlesky
  const ks = new THREE.DirectionalLight(0xffffff, 0.0001); ks.position.set(430, 170, 640); scene.add(ks);
  ks.castShadow = true; ks.shadow.mapSize.set(2048, 2048); ks.shadow.bias = -0.0006;
  Object.assign(ks.shadow.camera, {left:-320, right:320, top:320, bottom:-320, near:150, far:1600}); ks.shadow.camera.updateProjectionMatrix();
  ground = new THREE.Mesh(new THREE.PlaneGeometry(3000, 3000), new THREE.ShadowMaterial({opacity:0.16}));
  ground.receiveShadow = true; ground.position.z = 0.05; scene.add(ground);
  const kb = new THREE.DirectionalLight(0xffffff, 0.7); kb.position.set(420,-260,-260); scene.add(kb);   // šikmé světlo zespodu: vystínuje vygravírované logo
  // hedvábné PLA: lesklý povrch s mírným lakem, odlesky z prostředí studia
  const mat = new THREE.MeshPhysicalMaterial({color:0xffffff, roughness:0.46, metalness:0.0, clearcoat:0.12, clearcoatRoughness:0.5, envMapIntensity:0.8});
  addLayerLines(mat);
  mesh = new THREE.Mesh(new THREE.BufferGeometry(), mat);
  mesh.castShadow = true;
  scene.add(mesh);
  // měkký stín pod vázou
  const cv = document.createElement("canvas"); cv.width = cv.height = 128;
  const g = cv.getContext("2d"), gr = g.createRadialGradient(64,64,4,64,64,64);
  gr.addColorStop(0,"rgba(0,0,0,0.30)"); gr.addColorStop(1,"rgba(0,0,0,0)"); g.fillStyle = gr; g.fillRect(0,0,128,128);
  shadow = new THREE.Mesh(new THREE.PlaneGeometry(1,1), new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(cv), transparent:true, depthWrite:false}));
  scene.add(shadow);
  // záběr podle největší velikosti (30 cm) – menší vázy jsou opravdu menší
  camera.position.copy(camHome()); controls.target.set(0,0,115);
  controls.update(); lockAz = controls.getAzimuthalAngle();
  controls.minAzimuthAngle = controls.maxAzimuthAngle = lockAz;
  new ResizeObserver(resize).observe(stage); resize();
  let lastRot = null;
  (function loop(){
    requestAnimationFrame(loop);
    if (spin && !bottomOn) turnVase(0.0045);
    if (mesh && mesh.rotation.z !== lastRot){ lastRot = mesh.rotation.z; renderer.shadowMap.needsUpdate = true; }   // stín se otáčí s vázou
    controls.update();
    shadow.visible = ground.visible = camera.position.z > controls.target.z*0.1;
    renderer.render(scene, camera);
  })();
  return true;
}
function resize(){
  if (!renderer) return;
  const w = stage.clientWidth, h = stage.clientHeight;
  renderer.setSize(w, h, false); camera.aspect = w/h;
  camera.updateProjectionMatrix();
}
// hladké normály jen mezi podobně skloněnými plochami (ostré hrany žeber zůstanou ostré)
function smoothGeometry(m){
  const I = m.idx, p = m.pos, T = I.length/3, nV = p.length/3;
  const fn = new Float32Array(T*3), ar = new Float32Array(T);
  for (let i=0;i<T;i++){
    const a=I[3*i]*3, b=I[3*i+1]*3, c=I[3*i+2]*3;
    const ux=p[b]-p[a], uy=p[b+1]-p[a+1], uz=p[b+2]-p[a+2], vx=p[c]-p[a], vy=p[c+1]-p[a+1], vz=p[c+2]-p[a+2];
    let nx=uy*vz-uz*vy, ny=uz*vx-ux*vz, nz=ux*vy-uy*vx; const L=Math.hypot(nx,ny,nz)||1;
    fn[3*i]=nx/L; fn[3*i+1]=ny/L; fn[3*i+2]=nz/L; ar[i]=L/2;
  }
  const cnt = new Uint32Array(nV+1);
  for (let i=0;i<I.length;i++) cnt[I[i]+1]++;
  for (let i=0;i<nV;i++) cnt[i+1]+=cnt[i];
  const fill = cnt.slice(0,nV), adj = new Uint32Array(I.length);
  for (let i=0;i<I.length;i++) adj[fill[I[i]]++] = (i/3)|0;
  const cosLim = Math.cos(38*Math.PI/180), P = new Float32Array(T*9), N = new Float32Array(T*9);
  for (let i=0;i<T;i++) for (let k=0;k<3;k++){
    const v = I[3*i+k], o = 9*i+3*k;
    P[o]=p[3*v]; P[o+1]=p[3*v+1]; P[o+2]=p[3*v+2];
    let nx=0, ny=0, nz=0;
    for (let j=cnt[v]; j<cnt[v+1]; j++){ const f = adj[j];
      if (fn[3*f]*fn[3*i]+fn[3*f+1]*fn[3*i+1]+fn[3*f+2]*fn[3*i+2] > cosLim){ nx+=fn[3*f]*ar[f]; ny+=fn[3*f+1]*ar[f]; nz+=fn[3*f+2]*ar[f]; } }
    const L = Math.hypot(nx,ny,nz)||1; N[o]=nx/L; N[o+1]=ny/L; N[o+2]=nz/L;
  }
  const g = new THREE.BufferGeometry();
  g.setAttribute("position", new THREE.BufferAttribute(P,3));
  g.setAttribute("normal", new THREE.BufferAttribute(N,3));
  return g;
}

// zastínění (ambient occlusion) spočtené z geometrie: hloubka v mezeře mezi žebry a její šířka
function addAO(g, d){
  const P = g.attributes.position.array, Nn = g.attributes.normal.array, n = P.length/3, A = new Float32Array(n);
  const s = d.H/200, inner = d.Rt - d.wall*0.5;
  for (let i=0;i<n;i++){
    const x = P[3*i], y = P[3*i+1], z = P[3*i+2], nz = Nn[3*i+2], r = Math.hypot(x, y);
    let ao = 1;
    if (z < 0.05 && nz < -0.7) ao = 1;                                   // dno
    else if (z > d.H - 0.05 && nz > 0.7) ao = 1;                         // horní hrana hrdla
    else if (r < inner) ao = 0.3 + 0.7*Math.min(1, Math.max(0, (z - (d.H - 30*s))/(30*s)));   // vnitřek trubky
    else {
      const Rtip = Math.max(d.R(Math.min(d.H, Math.max(0, z))), d.Rt + 0.1), depth = Rtip - d.Rt;
      const tt = Math.min(1, Math.max(0, (r - d.Rt)/depth));
      const gap = 2*Math.PI*(d.Rt + depth*0.5)/d.N;                    // šířka mezery v půlce hloubky
      const minAO = Math.min(0.85, Math.max(0.32, 0.22 + 0.4*gap/depth));
      ao = minAO + (1 - minAO)*Math.pow(tt, 0.65);
    }
    A[i] = ao;
  }
  g.setAttribute("ao", new THREE.BufferAttribute(A, 1));
}

/* ---------- přepočet ---------- */
let pending = false, lastKey = "", rmax = 0;
function schedule(){
  if (pending) return; pending = true;
  $("vzBusy").textContent = t("building"); $("vzBusy").hidden = false;
  requestAnimationFrame(() => setTimeout(rebuild, 0));
}
function rebuild(){
  pending = false;
  applySelection();
  const key = JSON.stringify([pick.style, pick.preset, pick.H, pick.custom]);
  if (key !== lastKey && mesh){
    const d = derive(), m = buildMesh(d);
    rmax = 0; for (let i=0;i<m.pos.length;i+=3) rmax = Math.max(rmax, Math.hypot(m.pos[i], m.pos[i+1]));
    const old = mesh.geometry; mesh.geometry = smoothGeometry(m); addAO(mesh.geometry, d); old.dispose();
    const r = rmax*2.1; shadow.scale.set(r, r, 1); shadow.position.set(0,0,0.2);
    renderer.shadowMap.needsUpdate = true;
    lastKey = key;
  }
  // vrstvy vykreslené zvětšeně (skutečných 0,2–0,3 mm by bylo menší než pixel); roste s velikostí vázy jako tryska
  layerH.value = pick.H >= 300 ? 0.7 : 0.5;
  if (mesh) colorize();
  $("vzBusy").hidden = true;
  renderInfo();
}

// jednobarevná: barva materiálu; MAGIC: barva vrcholu podle úhlu kolem osy (strany vázy)
function colorize(){
  const mat = mesh.material, g = mesh.geometry;
  if (!isMagic(pick.color)){
    const c = new THREE.Color(pick.color[1]).convertSRGBToLinear();
    mat.color.copy(c); if (mat.vertexColors){ mat.vertexColors = false; mat.needsUpdate = true; }
    return;
  }
  const cols = pick.color[2].map(h => new THREE.Color(h).convertSRGBToLinear()), n = cols.length, bias = MAGIC_BIAS[pick.color[0]] || [];
  const P = g.attributes.position.array, C = new Float32Array(P.length);
  for (let i=0;i<P.length;i+=3){
    const a = Math.atan2(P[i+1], P[i]);
    let r=0, gg=0, b=0, ws=0;
    for (let k=0;k<n;k++){
      const d = Math.cos(a - (Math.PI*2*k/n) - Math.PI/4);
      const w = (Math.pow((1 + d)/2, n === 2 ? 0.8 : 1.2) + 1e-4) * (bias[k] || 1);   // široký, plynulý přechod mezi barvami
      r += cols[k].r*w; gg += cols[k].g*w; b += cols[k].b*w; ws += w;
    }
    // vyšší sytost (odlesky prostředí barvy zesvětlují)
    const R = r/ws, G = gg/ws, B = b/ws, L = 0.2126*R + 0.7152*G + 0.0722*B, k = 1.35;
    C[i] = Math.max(0, L + (R - L)*k); C[i+1] = Math.max(0, L + (G - L)*k); C[i+2] = Math.max(0, L + (B - L)*k);
    // dno vygravírovaného loga (jediné body ve výšce 0,05–0,85 mm) o něco tmavší, aby se logo dalo přečíst
    const z = P[i+2]; if (z > 0.05 && z < settings.LD + 0.05){ C[i] *= 0.55; C[i+1] *= 0.55; C[i+2] *= 0.55; }
  }
  g.setAttribute("color", new THREE.BufferAttribute(C, 3));
  mat.color.set(0xffffff); if (!mat.vertexColors){ mat.vertexColors = true; mat.needsUpdate = true; }
}
function magicDelta(){
  const m = CFG.variants, sfx = " / " + shapeNo(pick.preset) + " / " + (pick.H/10) + " CM";
  if (m && m["magic-" + pick.style] && m[pick.style]){
    const a = Object.entries(m["magic-" + pick.style]).find(([k]) => k.endsWith(sfx)), b = Object.entries(m[pick.style]).find(([k]) => k.endsWith(sfx));
    if (a && b) return a[1][1] - b[1][1];
  }
  return CFG.magicPrices[pick.H] - CFG.prices[pick.H];
}
const priceOf = () => { const v = variantOf(); return v ? v[1] : (isMagic(pick.color) ? CFG.magicPrices : CFG.prices)[pick.H]; };
const productOf = () => (isMagic(pick.color) ? CFG.magicProducts : CFG.products)[pick.style];

/* ---------- ovládání ---------- */
function shapeThumb(cv, style, preset){
  const dpr = Math.min(2, window.devicePixelRatio || 1), W = cv.clientWidth || 70, H = cv.clientHeight || 78;
  cv.width = W*dpr; cv.height = H*dpr;
  const g = cv.getContext("2d"); g.setTransform(dpr,0,0,dpr,0,0);
  const st = presetState(style, preset), f = curveFn(st);
  const sc = (H-8)/200, cx = W/2, by = H-4;
  g.beginPath();
  for (let i=0;i<=80;i++){ const z=i/80, x=cx+f(z)*sc, y=by-z*200*sc; i ? g.lineTo(x,y) : g.moveTo(x,y); }
  for (let i=80;i>=0;i--){ const z=i/80; g.lineTo(cx-f(z)*sc, by-z*200*sc); }
  g.closePath(); g.fillStyle = "#000"; g.fill();
}
function renderStyles(){
  const el = $("vzStyles"); el.textContent = "";
  for (const s of ["wave","spiral","zigzag"]){
    const b = document.createElement("button"); b.type = "button"; b.className = "chip" + (pick.style === s ? " on" : "");
    b.textContent = STYLES[s].name; b.setAttribute("aria-pressed", pick.style === s);
    b.addEventListener("click", () => { if (pick.style === s) return; pick.style = s; pick.preset = firstPreset(s); pick.custom = {}; renderAll(); schedule(); });
    el.appendChild(b);
  }
}
function renderShapes(){
  const el = $("vzShapes"); el.textContent = "";
  for (const p of Object.keys(STYLES[pick.style].presets)){
    const b = document.createElement("button"); b.type = "button"; b.className = "chip" + (pick.preset === p ? " on" : "");
    b.setAttribute("aria-label", label(p)); b.setAttribute("aria-pressed", pick.preset === p);
    b.textContent = shapeNo(p); el.appendChild(b);
    b.addEventListener("click", () => { if (pick.preset === p) return; pick.preset = p; pick.custom = {}; renderAll(); schedule(); });
  }
}
function renderSizes(){
  const el = $("vzSizes"); el.textContent = "";
  for (const h of SIZES){
    const b = document.createElement("button"); b.type = "button"; b.className = "chip" + (pick.H === h ? " on" : "");
    b.setAttribute("aria-pressed", pick.H === h);
    b.textContent = (h/10) + " CM"; el.appendChild(b);
    b.addEventListener("click", () => { pick.H = h; renderSizes(); renderColors(); renderSliders(); schedule(); });
  }
}
function renderColors(){
  const add = (c, box) => {
    const b = document.createElement("button"); b.type = "button"; b.className = "swatch" + (pick.color[0] === c[0] ? " on" : "");
    const sw = document.createElement("i"); sw.style.background = swatchBg(c); b.append(sw); b.title = c[0]; b.setAttribute("aria-label", c[0]); b.setAttribute("aria-pressed", pick.color[0] === c[0]);
    b.addEventListener("click", () => { pick.color = c; renderColors(); rebuild(); });
    box.appendChild(b);
  };
  const mg = $("vzMagic"); mg.textContent = ""; for (const c of MAGIC) add(c, mg);
  $("vzColorName").textContent = pick.color[0];
}
function renderSliders(){
  const el = $("vzSliders"); el.textContent = "";
  const o = originalOf(pick.style, pick.preset);
  for (const c of CUSTOM[pick.style]){
    const max = rangeMax(c), v = pick.custom[c.k] ?? o[c.k], id = "vz-" + c.k;
    const w = document.createElement("div"); w.className = "slider";
    const lb = document.createElement("label"); lb.htmlFor = id; lb.textContent = t(c.label);
    const out = document.createElement("output"); out.htmlFor = id; out.textContent = fmtCustom(c.k, v);
    const inp = document.createElement("input"); inp.type = "range"; inp.id = id; inp.min = c.min; inp.max = max; inp.step = c.step; inp.value = v;
    const ends = document.createElement("div"); ends.className = "ends";
    const e1 = document.createElement("span"), e2 = document.createElement("span");
    e1.textContent = fmtCustom(c.k, c.min); e2.textContent = fmtCustom(c.k, max); ends.append(e1, e2);
    const set = v => { v = Math.min(max, Math.max(c.min, +(+v).toFixed(4))); inp.value = v; pick.custom[c.k] = v; out.textContent = fmtCustom(c.k, v); $("vzReset").disabled = isOriginal(); schedule(); };
    inp.addEventListener("input", () => set(inp.value));
    const mk = (s, d) => { const b = document.createElement("button"); b.type = "button"; b.className = "step"; b.textContent = s; b.setAttribute("aria-label", t(c.label) + " " + s); b.addEventListener("click", () => set(+inp.value + d*c.step)); return b; };
    w.append(lb, out, mk("−", -1), mk("+", 1), inp, ends); el.appendChild(w);
  }
  $("vzReset").disabled = isOriginal();
}
function money(v){ return v == null ? "" : v.toLocaleString(lang === "cs" ? "cs-CZ" : "en-US", {minimumFractionDigits:2, maximumFractionDigits:2}) + " " + CFG.currency; }
function customProps(){
  const props = {};
  if (!isOriginal()){
    const o = originalOf(pick.style, pick.preset);
    for (const c of CUSTOM[pick.style]) props[t(c.label)] = fmtCustom(c.k, pick.custom[c.k] ?? o[c.k]);
  }
  // úplný kód návrhu pro plnou Vázovnu (skrytý, začíná podtržítkem)
  const code = {v:1, style:pick.style, preset:pick.preset, H:pick.H};
  for (const c of CUSTOM[pick.style]) code[c.k] = state[c.k];
  props._vazovna = JSON.stringify(code);
  return props;
}
function variantTitle(){ return pick.color[0] + " / " + shapeNo(pick.preset) + " / " + (pick.H/10) + " CM"; }
const variantKey = () => (isMagic(pick.color) ? "magic-" : "") + pick.style;
// varianta z obchodu: [id, cena] nebo null (v ukázce bez napojení)
const variantOf = () => { const m = CFG.variants && CFG.variants[variantKey()]; return m ? m[variantTitle().toUpperCase()] || null : null; };
function renderInfo(){
  $("vzName").textContent = STYLES[pick.style].name + " " + shapeNo(pick.preset);
  $("vzCrumb").textContent = STYLES[pick.style].name + " " + shapeNo(pick.preset);
  $("vzDims").textContent = "Ø " + nf(2*rmax, 0) + " × " + nf(pick.H, 0) + " mm";
  $("vzPrice").textContent = money(priceOf()); $("vzMPrice").textContent = money(priceOf());
  const spec = $("vzSpec"); spec.textContent = "";
  const o = originalOf(pick.style, pick.preset);
  const rows = [[t("specCollection"), STYLES[pick.style].name], [t("specShape"), shapeNo(pick.preset)], [t("specSize"), (pick.H/10) + " cm"], [t("specColor"), pick.color[0] + (isMagic(pick.color) ? " (PLA MAGIC)" : " (rPLA)")]];
  if (isOriginal()) rows.push([t("specCustom"), t("original")]);
  else for (const c of CUSTOM[pick.style]) rows.push([t(c.label), fmtCustom(c.k, pick.custom[c.k] ?? o[c.k])]);
  for (const [a,b] of rows){ const dt = document.createElement("dt"), dd = document.createElement("dd"); dt.textContent = a; dd.textContent = b; spec.append(dt, dd); }
  if (CFG.demo){
    $("vzCartNote").textContent = t("demoNote");
    const p = customProps();
    $("vzPayload").textContent = productOf() + " — " + variantTitle() + "\n" + Object.entries(p).map(([k,v]) => k + ": " + v).join("\n");
    $("vzPayload").hidden = false;
  }
}
function applyLang(){
  document.querySelectorAll("#vzc [data-t]").forEach(e => e.textContent = t(e.dataset.t));
  document.querySelectorAll("#vzc .lang button").forEach(b => b.classList.toggle("on", b.dataset.l === lang));
  renderSizes(); renderSliders(); renderInfo();
}
document.querySelectorAll("#vzc .lang button").forEach(b => b.addEventListener("click", () => { lang = b.dataset.l; applyLang(); }));
$("vzReset").addEventListener("click", () => { pick.custom = {}; renderSliders(); schedule(); });
// --- přidání do košíku: odolné vůči dočasným chybám Shopify (429) a nenačtenému seznamu variant ---
const HANDLES = {"wave":"wave-vase", "spiral":"spiral-vase", "zigzag":"zigzag-vase",
  "magic-wave":"wave-vase-magic-color", "magic-spiral":"spiral-vase-magic", "magic-zigzag":"zigzag-vase-magic-color"};
const sleep = ms => new Promise(r => setTimeout(r, ms));
const storeUrl = p => (CFG.root || "/").replace(/\/?$/, "/") + p;
async function fetchRetry(url, opts, tries = 3){
  let r;
  for (let i = 0; i < tries; i++){
    r = await fetch(url, opts);
    if (r.status !== 429 && r.status < 500) return r;
    await sleep(800 * (i + 1));
  }
  return r;
}
let variantsLoading = null;
function loadVariants(){
  if (CFG.variants || !CFG.variantsUrl) return Promise.resolve();
  if (!variantsLoading) variantsLoading = fetchRetry(CFG.variantsUrl).then(r => r.json())
    .then(d => { CFG.variants = d.variants; renderColors(); renderInfo(); })
    .catch(e => { console.warn("Vazovna: seznam variant se nenačetl", e); })
    .finally(() => { variantsLoading = null; });
  return variantsLoading;
}
// ID varianty: ze seznamu, jinak přímo z produktu v obchodě (podle barvy / tvaru / velikosti)
async function resolveVariantId(){
  await loadVariants();
  const v = variantOf(); if (v) return v[0];
  const handle = HANDLES[variantKey()]; if (!handle) return null;
  const r = await fetchRetry(storeUrl("products/" + handle + ".js"));
  if (!r.ok) return null;
  const p = await r.json(), want = variantTitle().toUpperCase().replace(/\s+/g, " ");
  const hit = (p.variants || []).find(x => String(x.title).toUpperCase().replace(/\s+/g, " ") === want);
  return hit ? hit.id : null;
}
let adding = false;
$("vzCart").addEventListener("click", async () => {
  if (CFG.demo){ $("vzPayload").hidden = false; $("vzPayload").scrollIntoView({block:"nearest", behavior:"smooth"}); return; }
  if (adding) return; adding = true;
  const note = $("vzCartNote");
  try {
    const id = await resolveVariantId();
    if (!id) throw new Error("varianta nenalezena: " + variantTitle());
    const r = await fetchRetry(CFG.cartAddUrl ? CFG.cartAddUrl + ".js" : storeUrl("cart/add.js"),
      {method:"POST", headers:{"Content-Type":"application/json", "Accept":"application/json"}, body:JSON.stringify({items:[{id, quantity:1, properties:customProps()}]})});
    if (!r.ok){ let msg = "HTTP " + r.status; try { const j = await r.json(); msg = j.description || j.message || msg; } catch (e) {} throw new Error(msg); }
    note.textContent = t("cartOk");
    if (CFG.cartUrl) window.location.href = CFG.cartUrl;
  } catch (e) {
    console.warn("Vazovna: přidání do košíku selhalo", e);
    note.textContent = t("cartErr") + " (" + e.message + ")";
  } finally { adding = false; }
});
$("vzLang").hidden = !CFG.demo;
if (CFG.root) $("vzHome").href = CFG.root;   // v obchodě jazyk určuje šablona
// pohled zespodu na logo / zpět z boku
let bottomOn = false;
$("vzBottom").addEventListener("click", () => {
  if (!camera) return;
  bottomOn = !bottomOn; spin = !bottomOn;
  controls.minAzimuthAngle = bottomOn ? -Infinity : lockAz; controls.maxAzimuthAngle = bottomOn ? Infinity : lockAz;
  controls.minPolarAngle = bottomOn ? 0 : Math.PI*0.12; controls.maxPolarAngle = bottomOn ? Math.PI : Math.PI*0.58;
  if (bottomOn){ const s = pick.H/200; camera.position.set(0, 40*s, -260*s - 60); controls.target.set(0, 0, 0); }   // kladné y: logo je zespodu vidět správně natočené
  else { camera.position.copy(camHome()); controls.target.set(0, 0, 115); }
  $("vzBottom").textContent = t(bottomOn ? "sideView" : "bottomView");
});
$("vzMCart").addEventListener("click", () => $("vzCart").click());
const mobile = matchMedia("(max-width:900px)").matches;
if (mobile) $("vzDetails").open = false;
function renderAll(){ renderStyles(); renderShapes(); renderSizes(); renderColors(); renderSliders(); applyLang(); }

renderAll();
initGL();
rebuild();
// v obchodě: načíst varianty (ID a ceny) ze souboru šablony
if (!CFG.demo) loadVariants();
})();
